/* PDP STORY: si el landing está embebido, forzar scroll de documento normal — el theme deja
   html como scroll-container de altura fija (overflow:auto !important) y eso rompe position:sticky
   de STACK/DISECCIÓN. Self-guarded: solo corre cuando hay #agc-landing en la página. */
(function(){ if(document.getElementById('agc-landing')){ var d=document.documentElement,b=document.body;
  d.style.setProperty('overflow','visible','important'); d.style.setProperty('height','auto','important');
  b.style.setProperty('overflow','visible','important'); b.style.setProperty('height','auto','important'); } })();
/* ============================================================
   AGC CONFIGURATOR JS — iyO-inspired PDP (Fase 1)
   Datos reales via window.AGC_CFG (inyectado por la sección Liquid).
   Carrito real: /cart/add.js + cart-drawer.renderContents() del theme.
   Mapping (FASE0-GROUND-TRUTH.md):
     tier  = quantity del variant elegido
     color = variant_id
     plan  = selling_plan (siempre — subscription-only)
     +Set Anual = línea one-time extra
     descuento tier = automatic discount Shopify (no requiere código)
   ============================================================ */
(function () {
  'use strict';
  var CFG = window.AGC_CFG;
  if (!CFG) return;
  /* BLINDAJE tier→plan: no confiar en el orden que Shopify devuelve los selling_plan_groups.
     El descuento del plan crece con el tier (1<2<3 baños = 25<33<40%), así que ordenamos por
     pct ascendente → tierPlans[0]=tier1, [1]=tier2, [2]=tier3 sin importar el orden de origen. */
  if (CFG.tierPlans && CFG.tierPlans.length) {
    CFG.tierPlans = CFG.tierPlans.slice().sort(function (a, b) { return (parseFloat(a.pct) || 0) - (parseFloat(b.pct) || 0); });
  }
  var root = document.getElementById('agc-cfg');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var fmt = function (cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); };

  /* El video frame-scrub NO se tinta por color (decisión Pedro 2026-06-12):
     cada acabado tendrá su propio set de frames más adelante. El cambio de
     color solo actualiza variante, precio y thumb (foto real del acabado). */
  var state = { tier: 1, colorKey: null, colors: [], step: 'config', anual: false, busy: false };   /* T2 preseleccionado (Pedro 2026-07-07, test AOV) */

  /* primer color disponible = default */
  var firstAvail = CFG.colors.filter(function (c) { return c.available; })[0] || CFG.colors[0];
  state.colorKey = firstAvail.key;
  state.colors = [firstAvail.key]; /* color por ducha (T2/T3); default todas = 1er color */

  function colorByKey(k) {
    for (var i = 0; i < CFG.colors.length; i++) if (CFG.colors[i].key === k) return CFG.colors[i];
    return CFG.colors[0];
  }

  /* ── pricing engine (centavos, desde precio real del variant) ──
     MODELO NUEVO: el % del descuento vive en el selling plan de CADA tier
     (CFG.tierPlans[tier-1].pct). Sin Kaching/RITUAL-A0, sin espejo subPct+tierNPct.
     base 2580 → tier1 1935 (25%), tier2 3457 (33%), tier3 4644 (40%). */
  function tierPricing(tier) {
    /* OFERTA (Pedro 2026-06-26): si el deal define precio promo (now/was), se usa para DISPLAY. ⚠️ el cobro real lo aplica el selling plan de Shopify — deben cuadrar (planes 30/30/42). */
    var d = (CFG.deals && CFG.deals[tier - 1]) || {};
    if (d.now != null && d.was != null) return { gross: d.was, final: d.now };
    var base = colorByKey(state.colorKey).price; // centavos, precio lista
    var pl = (CFG.tierPlans && CFG.tierPlans[tier - 1]) ? CFG.tierPlans[tier - 1] : null;
    var pct = pl ? pl.pct : CFG.subPct;
    var gross = base * tier;
    var final_ = Math.round(gross * (1 - pct / 100));
    return { gross: gross, final: final_ };
  }
  function renewCents(tier) {
    var base = colorByKey(state.colorKey).price;
    return Math.round(base * (1 - CFG.renewPct / 100)) * tier;
  }
  function totals() {
    var t = tierPricing(state.tier);
    return { today: t.final, gross: t.gross, renew: renewCents(state.tier) };
  }

  /* ── showroom escena 0: filmstrip ancho derivando (2 copias seamless) + tinte ── */
  var strip = $('#agcStrip');
  var hotTrack = $('#agcHeroHotsTrack');
  var stripBuilt = {};
  /* drift JS-driven (auto-drift + swipe manual) · 3 copias = loop infinito seamless bidireccional */
  var COPIES = 3;
  var heroOffset = 0, heroCopyW = 0, heroDragging = false, heroResumeAt = 0, heroInit = false, heroPaused = false, heroFling = 0, heroLastNow = 0;
  /* TEST (Pedro 2026-06-23): INTRO estático navegado por flecha. heroTour es ESTADO DERIVADO (reversible),
     no un flag de una vía: evalHeroMode() lo recalcula cada frame desde el estado real. tour = reposo escena-0
     (flecha + estático); drift = card/cart/3D/menú abierto o scroll a la narrativa. Al volver atrás re-entra
     el tour (flecha reaparece + re-centra bullet). El cambio de color con las islas NO anima (swap en sitio,
     estático). Ver atScene0Rest/setHeroTour/evalHeroMode. */
  var heroTour = true, heroTweening = false, heroTweenTo = 0;
  function buildStrip(key) {
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    strip.innerHTML = '';
    heroCopyW = 0; heroInit = false; /* recalcular tras swap de color */
    for (var i = 0; i < COPIES; i++) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'eager'; /* misma URL → cacheada; deben tener ancho para el loop */
      if (key === firstAvail.key && i === 0) im.fetchPriority = 'high';
      strip.appendChild(im);
    }
    stripBuilt[key] = true;
  }
  function heroDrift() {
    if (strip) {
      evalHeroMode();   /* deriva tour↔drift del estado real cada frame (reversible) */
      if (!heroCopyW && strip.scrollWidth > 0) heroCopyW = strip.scrollWidth / COPIES;
      if (heroCopyW && !heroInit) { heroOffset = -heroCopyW; heroInit = true; if (heroTour) requestAnimationFrame(function () { centerToBullet(0); }); } /* centra en copia media; en intro centra el 1er bullet */
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      /* delta-time: animación por TIEMPO, no por frame → misma velocidad en cualquier FPS (Chrome, in-app Meta/IG, ProMotion 120Hz) */
      var dt = heroLastNow ? Math.min(now - heroLastNow, 50) : 16.67; heroLastNow = now;
      var fr = dt / 16.67; /* factor vs 60fps */
      if (heroTour) {
        /* INTRO estático: sin auto-drift; tween suave hacia el bullet objetivo (flecha / snap de swipe) */
        if (!heroDragging && heroTweening) {
          heroOffset += (heroTweenTo - heroOffset) * Math.min(1, 0.26 * fr);   /* 0.16→0.26 (Pedro 2026-07-03): menos cola lenta al llegar al lock del paso color */
          if (Math.abs(heroTweenTo - heroOffset) < 1) { heroOffset = heroTweenTo; heroTweening = false; }
        }
      } else if (!heroDragging && !heroPaused) {
        /* CONFIGURANDO (Pedro 2026-06-24): ya NO hay auto-drift — el fondo se LOCKEA en el bullet 3 (estático) para no distraer al que está configurando. Solo el tween de aterrizaje hacia el bullet lockeado. */
        if (heroTweening) {
          heroOffset += (heroTweenTo - heroOffset) * Math.min(1, 0.26 * fr);   /* 0.16→0.26 (Pedro 2026-07-03): menos cola lenta al llegar al lock del paso color */
          if (Math.abs(heroTweenTo - heroOffset) < 1) { heroOffset = heroTweenTo; heroTweening = false; }
        }
      }
      if (heroCopyW && !heroTweening) { /* mantener offset en [-2W, -W): copia media siempre llena. NO normalizar a media-tween (rompe el centrado del bullet); las copias son idénticas → el snap por W es invisible */
        while (heroOffset <= -2 * heroCopyW) heroOffset += heroCopyW;
        while (heroOffset > -heroCopyW) heroOffset -= heroCopyW;
      }
      /* translate3d → capa GPU dedicada: el drift se compositea en hardware, suave en TODOS los browsers
         (Chrome, Safari, in-app Meta/IG/TikTok). Con translateX 2D el webview rasterizaba en CPU → "mini pasitos". Pedro 2026-06-23 */
      strip.style.transform = 'translate3d(' + heroOffset + 'px,0,0)';
      if (hotTrack) hotTrack.style.transform = 'translate3d(' + heroOffset + 'px,0,0)'; /* los hotspots viajan con las imágenes */
    }
    requestAnimationFrame(heroDrift);
  }
  requestAnimationFrame(heroDrift);
  /* ── INTRO: flecha glassy → centra el siguiente bullet. INDEX-based (determinista): cada hotspot tiene su
     left% conocido; el target absoluto centra esa fracción de la copia media (heroOffset = cx − copyW·(1+f)). ── */
  var tourIdx = 0;
  var HERO_LOCK_BULLET = 2;   /* bullet 3 (0-based índice 2) — escena en la que se lockea el fondo al configurar. Pedro 2026-06-24 */
  function nBullets(hots) { return Math.round(hots.length / 3) || 8; }   /* 3 copias del strip */
  function centerToBullet(i, dir) {
    var hots = $$('#agcHeroHots .agc-hh'); if (!hots.length || !heroCopyW) return;
    var n = nBullets(hots); tourIdx = ((i % n) + n) % n; dir = dir || 0;
    /* de las 3 instancias del bullet tourIdx (copias): dir>0 → la más cercana a la DERECHA (loop hacia la derecha, sin rebobinar al pasar último→primero); dir<0 → la más cercana a la IZQUIERDA; dir=0 → la más cercana (snap/lock). Pedro 2026-06-25 */
    var cx = window.innerWidth / 2, best = null, bd = Infinity, k, r, off, d;
    for (k = tourIdx; k < hots.length; k += n) {
      r = hots[k].getBoundingClientRect(); if (!r.width) continue;
      off = r.left + r.width / 2 - cx;
      if (dir > 0) { if (off <= 4) continue; d = off; }        /* solo instancias a la derecha */
      else if (dir < 0) { if (off >= -4) continue; d = -off; } /* solo a la izquierda */
      else d = Math.abs(off);
      if (d < bd) { bd = d; best = r; }
    }
    if (!best) { /* sin instancia en la dirección pedida (borde de las copias) → la más cercana */
      bd = Infinity;
      for (k = tourIdx; k < hots.length; k += n) { r = hots[k].getBoundingClientRect(); if (!r.width) continue; d = Math.abs(r.left + r.width / 2 - cx); if (d < bd) { bd = d; best = r; } }
    }
    if (!best) return;
    /* target ABSOLUTO: heroTweenTo = cx − stripX_bullet (independiente del offset actual → estable mid-tween) */
    /* (revertido 2026-06-27: el shift -26 del 1er bullet descentraba el bullet en mobile; default = dot en el centro) */
    heroTweenTo = heroOffset + (cx - (best.left + best.width / 2));
    heroTweening = true;
  }
  function centerNextHotspot() { if (heroTour && heroCopyW) centerToBullet(tourIdx + 1, 1); }
  function snapNearestBullet() {
    var hots = $$('#agcHeroHots .agc-hh'); if (!hots.length) return;
    var n = nBullets(hots), cx = window.innerWidth / 2, best = -1, bd = Infinity;
    hots.forEach(function (h, k) { var r = h.getBoundingClientRect(); if (!r.width) return; var d = Math.abs(r.left + r.width / 2 - cx); if (d < bd) { bd = d; best = k; } });
    if (best >= 0) centerToBullet(best % n);
  }
  /* ── ESTADO derivado (reversible): tour = reposo de la escena 0; drift = configurando ── */
  function atScene0Rest() {
    return onScene0()
      && !root.classList.contains('cfg-open')      /* card expandido */
      && !root.classList.contains('cart-mode')     /* carrito */
      && !root.classList.contains('show-3d')       /* vista 3D */
      && !document.documentElement.classList.contains('agcn-open'); /* menú */
  }
  function setHeroTour(on) {
    if (on === heroTour) return;
    heroTour = on; heroTweening = false; heroLastNow = 0;
    root.classList.toggle('hero-configuring', !on);    /* CSS: oculta/muestra la flecha */
    if (on) snapNearestBullet();                        /* volver al intro → re-centra el bullet más cercano + reaparece la flecha */
    else centerToBullet(HERO_LOCK_BULLET);              /* entrar a configurar → LOCKEA el fondo en el bullet 3, estático, sin distraer (Pedro 2026-06-24) */
  }
  /* fuente única de verdad: se llama cada frame desde heroDrift → captura TODA transición
     (scroll, abrir/cerrar card-cart-3D-menú, volver atrás). El cambio de color con las islas de
     variante NO anima: setHeroColor swapea el color EN SITIO y el showroom se queda estático (Pedro 2026-06-23). */
  function evalHeroMode() { setHeroTour(atScene0Rest()); }
  var heroArrow = $('#agcHeroArrow');
  /* pointerdown (no click): dispara al PRESIONAR → no depende de dónde suelta el cursor (el botón se reposiciona cada frame por el drift del hero + el :active; con click, soltar en la orilla caía fuera). stopPropagation: que no lo secuestre el drag del hero. Pedro 2026-07-08. */
  if (heroArrow) heroArrow.addEventListener('pointerdown', function (e) { e.stopPropagation(); centerNextHotspot(); });
  /* click en cualquier bullet → centrar su escena (Pedro 2026-07-03) */
  var heroHotsEl = $('#agcHeroHots');
  if (heroHotsEl) heroHotsEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-revbtn]')) return;   /* el botón Ver reseñas conserva su acción */
    var h = e.target.closest('.agc-hh'); if (!h || !heroTour || !heroCopyW) return;
    var hots = $$('#agcHeroHots .agc-hh'), k = hots.indexOf(h);
    if (k >= 0) centerToBullet(k % nBullets(hots));
  });
  var heroArrowPrev = $('#agcHeroArrowPrev');
  if (heroArrowPrev) heroArrowPrev.addEventListener('pointerdown', function (e) { e.stopPropagation(); if (heroTour && heroCopyW) centerToBullet(tourIdx - 1, -1); });
  /* SPEED (2026-06-24): NO precargar las 8 imágenes (2.35MB) en el critical path del boot — el strip activo ya entra por el preload del LCP. Los otros 3 colores + las 4 galerías "elegir" se decodifican al PRIMER pointerdown en el configurador (= intención de configurar) o en idle tardío (4s, fuera del critical path). Así el swap de color y la galería siguen instantáneos tras la 1ª interacción, sin pesar en el LCP. */
  var _cfgPreloaded = false;
  function preloadConfigAssets() {
    if (_cfgPreloaded) return; _cfgPreloaded = true;
    if (CFG.heroStrips) Object.keys(CFG.heroStrips).forEach(function (k) { var p = new Image(); p.src = CFG.heroStrips[k]; if (p.decode) p.decode().catch(function () {}); });
    if (CFG.elegirStrips) Object.keys(CFG.elegirStrips).forEach(function (k) { var p = new Image(); p.src = CFG.elegirStrips[k]; if (p.decode) p.decode().catch(function () {}); });
  }
  /* dispara en la PRIMERA interacción real (scroll/tap) — NO en idle (requestIdleCallback dispara a ~1-2s y volvía a competir con el LCP). Si el usuario rebota sin interactuar, nunca se descargan los 2.35MB. */
  ['pointerdown', 'touchstart', 'scroll'].forEach(function (ev) { window.addEventListener(ev, preloadConfigAssets, { once: true, passive: true }); });
  function setHeroColor(key) {
    $$('.agc-htint').forEach(function (t) { t.classList.toggle('on', t.classList.contains('h-' + key)); });
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    var imgs = strip.querySelectorAll('img');
    if (!imgs.length) { buildStrip(key); return; }
    /* swap de src EN SITIO — layout idéntico → la animación NO se reinicia, solo cambia el color */
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].getAttribute('src') !== src) imgs[i].src = src; }
  }

  /* ── render ── */
  function syncThumb() {
    var c = colorByKey(state.colorKey);
    var img = $('#agcThumbImg');
    /* swap del thumb vía decode() — evita el "recuadro con sombra": si seteamos src directo y el PNG no está cacheado, el img queda vacío un instante y el filter:drop-shadow se proyecta desde su caja cuadrada. Decodificamos primero y recién ahí swapeamos (el thumb viejo se queda hasta que el nuevo esté listo). Pedro 2026-06-22 */
    if (img && c.img && img.getAttribute('src') !== c.img) {
      var pre = new Image(); pre.src = c.img;
      if (pre.decode) { pre.decode().then(function () { img.src = c.img; }).catch(function () { img.src = c.img; }); }
      else { img.src = c.img; }
    }
    var lado = $('#agcThumbLado');                                            /* expandido: foto de lado del acabado elegido */
    if (lado) { var lurl = (CFG.lado && CFG.lado[state.colorKey]) || ''; if (lurl && lado.getAttribute('src') !== lurl) lado.src = lurl; }
    var phimg = $('#agcProdHeroImg');                                         /* prod hero: misma foto de lado que el acabado activo (Pedro 2026-07-23) */
    if (phimg) { var purl = (CFG.lado && CFG.lado[state.colorKey]) || ''; if (purl && phimg.getAttribute('src') !== purl) phimg.src = purl; }
    $$('.agc-sw').forEach(function (x) { x.classList.toggle('on', x.dataset.c === state.colorKey); });
  }
  /* etiqueta de color del config: nombres REALES completos (Pedro 2026-07-23: "Chrome"/"Matte" era ambiguo entre Silver/Gold y Black/White). Mixto T2/T3 = última palabra (Silver/Black/Gold/White — única por color, no desborda) */
  function colorsLabel() {
    var full = function (s) { return s || ''; };
    var lw = function (s) { var p = (s || '').split(' '); return p[p.length - 1]; };
    if (state.tier === 1) { var c1 = colorByKey(state.colorKey); return full(c1 && c1.name); }
    var names = (state.colors || []).slice(0, state.tier).map(function (k) { var c = colorByKey(k); return full(c && c.name); }).filter(Boolean);
    if (!names.length) { var c0 = colorByKey(state.colorKey); return full(c0 && c0.name); }
    return names.every(function (n) { return n === names[0]; }) ? names[0] : names.map(lw).join(' + ');
  }
  function render() {
    var c = colorByKey(state.colorKey);
    var t = totals();
    var sep = '<span class="sep">/</span>';
    $('#agcCfgText').innerHTML = state.tier + ' shower' + (state.tier > 1 ? 's' : '') + ' ' + sep + ' ' + colorsLabel() + ' ' + sep + ' Aguacero Plus+';
    /* precio headline = tier 1 (1 unidad) con su plan: precio + precio de comparación (lista) */
    var ipNow = $('#agcIslPriceNow'), ipWas = $('#agcIslPriceWas');
    if (ipNow) { var t1 = tierPricing(1); ipNow.textContent = fmt(t1.final);
      if (ipWas) { if (t1.gross > t1.final) { ipWas.textContent = fmt(t1.gross); ipWas.style.display = ''; } else { ipWas.style.display = 'none'; } } }
    var headPrice = $('#agcHeadPrice'); if (headPrice) headPrice.textContent = fmt(t.today);
    var payBig = $('#agcPayBig'), renewBig = $('#agcRenewBig');
    if (payBig) payBig.textContent = fmt(t.today);
    if (renewBig) renewBig.textContent = fmt(t.renew);
    $('#agcColorName').textContent = c.name;
    var ctaPrice = $('#agcCtaPrice');
    if (ctaPrice) ctaPrice.textContent = fmt(t.today);
    /* deal card — el precio vive aquí, cambia con el tier (framing live) */
    var deal = CFG.deals[state.tier - 1] || CFG.deals[0];
    $('#agcDealTitle').textContent = deal.title;
    $('#agcDealOff').textContent = deal.off;
    var incEl = $('#agcDealInc'); if (incEl) incEl.innerHTML = deal.inc || '';
    $('#agcDealSub').textContent = deal.sub;
    /* Pedro 2026-06-21: precio TOTAL del tier en los 3 (sin "c/u"). Tachado = gross total
       (N × $2,580 = $2,580 / $5,160 / $7,740, espeja el deal de Kaching). */
    $('#agcDealNow').textContent = fmt(t.today);
    $('#agcDealCu').textContent = '';
    $('#agcDealWas').textContent = fmt(t.gross);
    /* Filtro = $290 por ducha. Plural en T2/T3. Plus+ lo regala (strike $X); única lo cobra ("Filtro(s) $X"). Pedro 2026-06-27 */
    var _plural = state.tier > 1;
    /* precio del filtro suelto desde CFG — antes estaba hardcodeado a 290 (pesos MX) y en US mostraba "+$290" (fix Pedro 2026-08-02) */
    var _fpx = fmt((CFG.filtroOncePrice || 3400) * state.tier);
    var _oncePx = document.querySelector('#agcPlan .agc-plan-row--once .agc-plan-tag--price');
    if (_oncePx) _oncePx.textContent = '+' + _fpx;   /* "+$290/+$580/+$870" */
    var _strike = document.querySelector('#agcPlan .agc-plan-strike');
    if (_strike) _strike.textContent = _fpx;
    var _fword = document.querySelector('#agcPlan .agc-plan-fword');
    if (_fword) _fword.textContent = _plural ? 'Starter filters' : 'Starter filter';
    var _bword = document.querySelector('#agcPlan .agc-plan-bword');
    if (_bword) _bword.textContent = _plural ? 'Your starter filters' : 'Your starter filter';
    var _perf = document.querySelector('#agcPlan .agc-plan-perf');
    if (_perf) _perf.textContent = _plural ? ' /filter' : '';   /* T2/T3: $590 es por filtro, no total */
    /* renovación DENTRO de la tarjeta Plus+ (Pedro 2026-08-03): precio POR FILTRO, nunca el total —
       ancla en $34 y evita el sobresalto del $102 en T3. El total real lo desglosa el checkout. */
    var _renewEl = document.querySelector('#agcPlan .agc-plan-renew');
    if (_renewEl) _renewEl.textContent = fmt(CFG.filtroRenewPrice || 3400) + (_plural ? '/filter' : '');
    /* ── desglose de cobro (Pedro 2026-08-02): "hoy pagas X · luego Y cada 90 días".
       Nace de la orden #ZERO21002: la clienta vio "$0 today" junto a un cargo de $301 y pidió reembolso.
       La renovación se calcula con el precio REAL del filtro (verificado: 3 filtros = $102), no con renewPct (heredado de MX). ── */
    var _psToday = $('#agcPayToday'), _psNext = $('#agcPayNext'), _psNextLb = $('#agcPayNextLb');
    if (_psToday && _psNext) {
      var _isOnce = (window.__agcPlan === 'once');
      var _fOnce = (CFG.filtroOncePrice || 1200) * state.tier;      /* Starter Filter — solo plan Base */
      var _fRenew = (CFG.filtroRenewPrice || 3400) * state.tier;    /* renovación real de la sub */
      _psToday.textContent = fmt(t.today + (_isOnce ? _fOnce : 0));
      /* nombre explícito del cargo + unidad: "2 filters" ancla en $34/filtro en vez del total pelón (Pedro 2026-08-03) */
      if (_psNextLb) _psNextLb.textContent = state.tier > 1
        ? ('Then, ' + state.tier + ' filters every 90 days')
        : 'Then, 1 filter every 90 days';
      _psNext.textContent = fmt(_fRenew);
      /* con Base no hay renovación → la fila entera desaparece (Pedro 2026-08-03) */
      var _nextRow = _psNext.parentNode;
      if (_nextRow) _nextRow.style.display = _isOnce ? 'none' : 'flex';
    }
    /* regalos incluidos por tier (filas con thumbnail, estilo Kaching): tapete T2+, Care T3 — Pedro 2026-06-26 */
    var anyGift = false;
    $$('#agcGifts .agc-gift').forEach(function (g) { var show = state.tier >= +g.getAttribute('data-gift-min'); g.style.display = show ? 'flex' : 'none'; if (show) anyGift = true; });
    var giftsBox = $('#agcGifts'); if (giftsBox) giftsBox.style.display = anyGift ? 'flex' : 'none';
    /* el selector de tier (config) SIEMPRE refleja state.tier — single source of truth.
       Evita desync: ej. al vaciar el carrito el back-arrow resetea state.tier a 1, pero antes
       el .on visual se quedaba en el tier viejo → mostraba 2 y agregaba 1. */
    $$('.agc-opt[data-tier]').forEach(function (x) { x.classList.toggle('on', +x.dataset.tier === state.tier); });
  }
  /* expuesto para el selector de plan (script inline del liquid): al cambiar Plus+/Base hay que
     recalcular el desglose Today/Then, si no se queda congelado en el plan anterior (Pedro 2026-08-03) */
  window.__agcRefresh = render;

  /* ── coreografía scroll + frame-scrub ── */
  var scroller = $('#agcScroller');
  var prod = $('#agcProd');
  var floor = $('#agcFloor');
  var frameImg = $('#agcFrame');
  var envs = [$('#agcE0'), $('#agcE1'), $('#agcE2'), $('#agcE3'), $('#agcE4')];
  var spot = $('#agcSpot');
  var dots = $$('.agc-dots b');
  var scenes = $$('.agc-scene');
  /* 6 escenas: 0=showroom (sin producto-video), 1=hero texto, 2=problema, 3=mecanismo, 4=prueba, 5=oferta */
  var ST = [
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 78, y: -6, s: 0.8, r: 7 },
    { x: 0, y: -18, s: 1.62, r: 0 },
    { x: -74, y: -4, s: 0.72, r: -7 },
    { x: 0, y: 18, s: 0.62, r: 0 }
  ];
  var NS = 5; /* índice máximo de escena (0..5) */
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var cl = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* frames: primeros 40 eager, resto en idle — total ~4MB */
  var NF = CFG.frameCount, FR = [];
  function frameUrl(n) { return CFG.frameBase.replace('001', String(n).padStart(3, '0')); }
  for (var n = 1; n <= NF; n++) FR.push(frameUrl(n));
  var preloaded = 0;
  function preload(upTo) {
    while (preloaded < upTo && preloaded < NF) { var im = new Image(); im.src = FR[preloaded]; preloaded++; }
  }
  /* SPEED (2026-07-02): los frames NO compiten con el LCP. En 4G el idle disparaba ~3.3MB
     al boot (requestIdleCallback = CPU libre, no red libre) y ahogaba el pipe del LCP.
     40 frames al primer gesto (intención de scrubbing) o post-load idle; los 182 solo tras load+idle.
     El scrub es on-demand (frameImg.src=FR[fi]) → sin precarga igual funciona. */
  var _fBoot = false;
  function preloadBoot() { if (_fBoot) return; _fBoot = true; preload(40); }
  ['pointerdown', 'touchstart', 'scroll', 'wheel'].forEach(function (ev) { window.addEventListener(ev, preloadBoot, { once: true, passive: true }); });
  function _afterLoad(f) { if (document.readyState === 'complete') { f(); } else { window.addEventListener('load', f, { once: true }); } }
  _afterLoad(function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(function () { preloadBoot(); preload(NF); });
  });

  var lastIdx = -1, lastScroll = -1;
  var showroom = $('#agcShowroom'), heroEnv = $('#agcHeroEnv'), prodstage = $('#agcProdstage'), colorPillEl = $('#agcColorPill');
  var heroHots = $('#agcHeroHots');
  /* ── media de fondo centrado EXACTO entre el techo de la web y el top de la isla oscura (prod/care hero) — solo mobile, isla abierta. El padding-bottom achica el área de centrado del flex; la isla crece → el media sube (Pedro 2026-07-23) ── */
  var islandForPad = $('#agcIsland');
  function syncShowroomPad() {
    if (!showroom || !islandForPad) return;
    if (window.innerWidth <= 1023 && root.classList.contains('cfg-open')) {
      var t = islandForPad.getBoundingClientRect().top;
      /* compensa el translateY inline del showroom (lift base -28 de tick()): el shift mueve el centro óptico ty px → se corrige 2·ty en el padding */
      var ty = 0, tr = getComputedStyle(showroom).transform;
      if (tr && tr !== 'none') { var m = tr.match(/-?[\d.]+/g); if (m && m.length >= 6) ty = parseFloat(m[5]) || 0; }
      var pb = Math.round(window.innerHeight - t + 2 * ty);
      if (pb > 0 && pb < window.innerHeight) { showroom.style.paddingBottom = pb + 'px'; return; }
    }
    showroom.style.paddingBottom = '';   /* colapsado/desktop: vuelve al CSS (25vh) */
  }
  if (window.ResizeObserver && islandForPad) new ResizeObserver(syncShowroomPad).observe(islandForPad);
  window.addEventListener('resize', syncShowroomPad, { passive: true });
  syncShowroomPad();
  var pillHeroVis = 1;
  function tick() {
    var H = scroller.clientHeight || 1;
    var top = scroller.scrollTop;
    if (top !== lastScroll) {
      lastScroll = top;
      /* fuera de la primera pantalla (scene 0) → la card colapsa a solo-footer + se ocultan colores/3D toggle */
      root.classList.toggle('scrolled', top > H * 0.5);
      root.classList.toggle('agc-tr-gone', top > 28 || (window.scrollY || 0) > 28); /* el toprail se va apenas scrollean (Pedro 2026-06-25) */
      var p = cl(top / H, 0, NS);
      /* handoff de capas: escena 0 = showroom puro; escenas 1+ = narrativa con video */
      var heroVis = cl(1 - p * 1.6, 0, 1);
      var videoVis = cl((p - 0.45) * 1.9, 0, 1);
      if (showroom) {
        showroom.style.opacity = heroVis;
        showroom.style.transform = 'translateY(' + (-p * 90 - 28) + 'px)';   /* -28 = lift base: el hero quedaba muy abajo con mucho espacio arriba (Pedro 2026-06-26) */
        showroom.style.visibility = heroVis === 0 ? 'hidden' : 'visible';
      }
      if (heroHots) {
        var hhHidden = root.classList.contains('cfg-open') || root.classList.contains('show-3d') || root.classList.contains('scrolled') || document.documentElement.classList.contains('agcn-open');
        heroHots.style.opacity = hhHidden ? 0 : heroVis;
        heroHots.style.transform = 'translateY(' + (-p * 90 - 28) + 'px)';   /* lift base espejo del showroom para que los hotspots no se desincronicen (Pedro 2026-06-26) */
        heroHots.style.visibility = (hhHidden || heroVis === 0) ? 'hidden' : 'visible';
      }
      pillHeroVis = heroVis;
      if (heroEnv) heroEnv.style.opacity = heroVis;
      if (prodstage) prodstage.style.opacity = videoVis;
      var i = Math.min(ST.length - 2, Math.floor(p)), t = p - i;
      var a = ST[i], b = ST[i + 1] || ST[i];
      prod.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      prod.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      prod.style.setProperty('--s', lerp(a.s, b.s, t));
      prod.style.setProperty('--r', lerp(a.r, b.r, t) + 'deg');
      floor.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      floor.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      floor.style.setProperty('--s', lerp(a.s, b.s, t));
      floor.style.opacity = cl(1 - Math.abs(p - 3), 0.15, 1) * videoVis;
      /* el video arranca fresco en la escena 1 (hero texto) y recorre su arco hasta la 5 */
      var vp = cl((p - 1) / (NS - 1), 0, 1);
      var fi = Math.min(NF - 1, Math.max(0, Math.round(vp * (NF - 1))));
      if (NF > 0 && frameImg && fi !== lastIdx) { frameImg.src = FR[fi]; lastIdx = fi; }
      /* envs e0..e4 acompañan las escenas narrativas 1..5 */
      envs.forEach(function (e, k) { if (e) e.style.opacity = cl(1 - Math.abs(p - (k + 1)), 0, 1); });
      if (spot) spot.style.opacity = cl(1 - Math.abs(p - 3) * 0.7, 0.2, 1);
      var cur = Math.round(p);
      dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
    }
    /* SIEMPRE (fuera del guard de scroll): el pill se oculta con menú/isla abiertos, sin depender de scroll */
    if (colorPillEl) {
      var pillVis = ((island && island.classList.contains('open')) || (nav && nav.classList.contains('open')) || document.documentElement.classList.contains('agcn-open')) ? 0 : pillHeroVis;
      colorPillEl.style.opacity = pillVis;
      colorPillEl.style.pointerEvents = pillVis > 0.5 ? 'auto' : 'none';
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  /* ── swipe horizontal del showroom con INERCIA estilo iyO (solo escena 0) ── */
  var hgStartX = 0, hgStartY = 0, hgStartOffset = 0, hgDir = null, hgLastX = 0, hgVel = 0;
  function onScene0() { return scroller.scrollTop < scroller.clientHeight * 0.5; }
  scroller.addEventListener('touchstart', function (e) {
    if (!onScene0()) return;
    var t = e.touches[0];
    hgStartX = t.clientX; hgStartY = t.clientY; hgStartOffset = heroOffset; hgDir = null;
    hgLastX = t.clientX; hgVel = 0; heroFling = 0; /* agarrar la imagen detiene la inercia previa */
  }, { passive: true });
  scroller.addEventListener('touchmove', function (e) {
    if (!onScene0() || hgDir === 'v') return;
    var t = e.touches[0];
    var dx = t.clientX - hgStartX, dy = t.clientY - hgStartY;
    if (hgDir === null && (Math.abs(dx) > 7 || Math.abs(dy) > 7)) {
      hgDir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'h' : 'v';
    }
    if (hgDir === 'h') {
      e.preventDefault();              /* el swipe horizontal no dispara el scroll vertical */
      heroDragging = true;
      heroOffset = hgStartOffset + dx;
      hgVel = (t.clientX - hgLastX) * 0.55 + hgVel * 0.45; /* velocidad suavizada (px/frame) */
      hgLastX = t.clientX;
    }
  }, { passive: false });
  function endHeroDrag() {
    if (hgDir === 'h') {
      if (heroTour) {
        /* un swipe normal = avanza UNA escena (igual que click a la flecha). Umbral bajo: cualquier
           deslizamiento real avanza; solo un toque casi inmóvil regresa al más cercano (Pedro 2026-06-24) */
        heroDragging = false;
        var _dx = heroOffset - hgStartOffset;   /* negativo = swipe izquierda → siguiente */
        /* deadzone 10px: cualquier swipe horizontal real avanza UNA escena (como click a la flecha) */
        if (_dx < -10 || hgVel < -0.25) centerToBullet(tourIdx + 1, 1);
        else if (_dx > 10 || hgVel > 0.25) centerToBullet(tourIdx - 1, -1);
        else snapNearestBullet();
      }
      else {
        heroDragging = false;
        centerToBullet(HERO_LOCK_BULLET);   /* configurando: el fondo está lockeado en bullet 3 → re-lockea tras cualquier arrastre (Pedro 2026-06-24) */
      }
    }
    hgDir = null; heroDragging = false;
  }
  scroller.addEventListener('touchend', endHeroDrag, { passive: true });
  scroller.addEventListener('touchcancel', endHeroDrag, { passive: true });

  /* ── Hotspots del hero: AUTO-narran al pasar por el centro de la pantalla (sin tap), con fade antes del borde —
     la imagen le "habla" al usuario, estilo Apple. Opacidad = caída suave según distancia al centro (Pedro 2026-06-20) ── */
  (function () {
    var hots = $$('#agcHeroHots .agc-hh');
    if (!hots.length) return;
    var cards = []; hots.forEach(function (h) { cards.push(h.querySelector('.agc-hh-card')); });
    var dots = []; hots.forEach(function (h) { dots.push(h.querySelector('.agc-hh-dot')); });
    var annEl = $('#agcAnnBar');
    /* SEAMLESS (Pedro 2026-07-07): antes corría a 70ms (~14fps) contra el strip a 60fps → opacidad a saltos, y la curva op² atenuaba AMBAS cards a ~25% en el cruce (flash oscuro). Ahora: 60fps con lecturas/escrituras separadas (cero layout thrash) + curva LINEAL (el cruce se mantiene brillante, crossfade constante). Cero fricción por frame. */
    function narrate() {
      var hidden = root.classList.contains('scrolled') || root.classList.contains('cfg-open') || root.classList.contains('show-3d') || document.documentElement.classList.contains('agcn-open');
      var isDsk = innerWidth >= 900;
      var cx = innerWidth / 2, band = isDsk ? Math.min(innerWidth * 0.16, 330) : innerWidth * 1.0;   /* mobile: banda ≈ separación entre bullets (~480px) para que el cruce no caiga a negro (Pedro 2026-07-07) */
      var annBottom = 0; if (annEl) { var arr = annEl.getBoundingClientRect(); if (arr.height) annBottom = arr.bottom; }
      var N = hots.length, hr = new Array(N), cr = new Array(N), k;
      for (k = 0; k < N; k++) { hr[k] = hots[k].getBoundingClientRect(); cr[k] = cards[k] ? cards[k].getBoundingClientRect() : null; }   /* FASE LECTURA en batch */
      for (k = 0; k < N; k++) {                                                                                                       /* FASE ESCRITURA en batch */
        var card = cards[k]; if (!card) continue;
        if (hidden) { card.style.opacity = '0'; continue; }
        var r = hr[k];
        if (!r.width) { card.style.opacity = '0'; continue; }
        var dx = Math.abs(r.left + r.width / 2 - cx);
        var t = dx >= band ? 1 : dx / band; var op = 1 - t * t;   /* PLATEAU (1-t²): centro brillante en zona amplia, cae rápido al borde → cruce sin dip oscuro (Pedro 2026-07-07) */
        if (!isDsk) {
          /* gate de borde (Pedro 2026-07-14): el texto del bullet VECINO no debe asomarse — se apaga cerca de los bordes del viewport. Margen 12% ≈ 47px: en el cruce (bullets a ~308px) ambos centros quedan a ~41px del borde → eop ~.87, el crossfade NO cae a negro. */
          var bcx = r.left + r.width / 2;
          var edge = Math.min(bcx, innerWidth - bcx), m = innerWidth * 0.12;
          op *= edge <= 0 ? 0 : edge >= m ? 1 : edge / m;
        }
        card.style.opacity = op.toFixed(3);
        if (dots[k]) dots[k].style.opacity = isDsk ? (0.3 + op * 0.7).toFixed(2) : '';
        if (op > 0.35 && annBottom && cr[k]) {
          var cur = parseFloat(card.style.getPropertyValue('--hhy')) || 0;
          var natTop = cr[k].top - cur;
          var need = (annBottom + 8) - natTop;
          card.style.setProperty('--hhy', need > 0 ? Math.round(need) + 'px' : '0px');
        } else {
          card.style.setProperty('--hhy', '0px');
        }
      }
    }
    (function loop() { narrate(); requestAnimationFrame(loop); })();
  })();

  /* ── Announcement bar: cicla 3 mensajes con crossfade+blur. Pace premium 4s (ref cro-patterns: ≥4s). ── */
  (function () {
    var bar = $('#agcAnnBar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.agc-annbar-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4000);
  })();

  /* ── Reseñas rotativas: crossfade premium 4.5s (mismo patrón que annbar). Pausa en reposo no requerida. ── */
  (function () {
    var box = $('#agcRevTkr');
    if (!box) return;
    var items = box.querySelectorAll('.agc-revtkr-item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4500);
  })();

  /* ── Promo bar: countdown live al domingo 23:59 CST + posicionado arriba del card (SOLO colapsado) ── */
  (function () {
    var bar = $('#agcPromoBar'); if (!bar) return;
    var tEls = document.querySelectorAll('.agc-promo-timer-val');   /* timer compartido: isla colapsada + barra expandida (Pedro 2026-06-21) */
    /* TARGET = hoy 23:59 CST; rueda DIARIO (Pedro 2026-06-22) → nunca expira, termina 11:59pm cada día */
    function computeTarget() {
      var now = Date.now(), OFF = 6 * 3600 * 1000; /* CST = UTC-6 */
      var cst = new Date(now - OFF);
      cst.setUTCHours(23, 59, 0, 0); /* hoy 23:59 CST */
      var ms = cst.getTime() + OFF;
      if (ms <= now) ms += 24 * 3600 * 1000; /* ya pasó → mañana 23:59 CST */
      return ms;
    }
    var TARGET = computeTarget();
    function fmt(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      return (d > 0 ? d + 'd ' : '') + p(h) + ':' + p(m) + ':' + p(s);
    }
    var timer;
    function tick() {
      var diff = TARGET - Date.now();
      if (diff <= 0) { TARGET = computeTarget(); diff = TARGET - Date.now(); }  /* rueda a la siguiente semana, NUNCA oculta las islas */
      var txt = fmt(diff);
      for (var i = 0; i < tEls.length; i++) tEls[i].textContent = txt;
    }
    function place() {
      /* las islas (Ver en acción / Reseñas / promo) SIEMPRE visibles en colapsado; el CSS las oculta al expandir */
      bar.hidden = false;
    }
    tick(); timer = setInterval(tick, 1000);
    window.__agcPlacePromo = place;
    window.addEventListener('resize', place);
    requestAnimationFrame(function () { requestAnimationFrame(place); });
  })();

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('show'); });
  }, { root: scroller, threshold: 0.55 });
  scenes.forEach(function (s) { io.observe(s); });

  /* ── menú bento (morph del nav pill, patrón iyO) ── */
  var nav = $('#agcNav'), navBg = $('#agcNavBg');
  var cycleTimer = null, cycleIdx = 0;
  function startCycle() {
    var imgs = $$('#agcMenuCycle img');
    if (!imgs.length || cycleTimer) return;
    cycleTimer = setInterval(function () {
      imgs[cycleIdx].classList.remove('on');
      cycleIdx = (cycleIdx + 1) % imgs.length;
      imgs[cycleIdx].classList.add('on');
    }, 2600);
  }
  function stopCycle() {
    if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
  }
  function closeMenu() {
    if (window.AGCNav) window.AGCNav.close();   /* barra compartida agc-nav */
    if (nav) nav.classList.remove('open');
    if (navBg) navBg.classList.remove('show');
    root.classList.remove('menu-open');
    stopCycle();
  }
  /* la barra compartida avisa al abrir → cerramos la isla de config (comportamiento original) */
  document.addEventListener('agcn:toggle', function (e) {
    if (!e.detail) return;
    var open = e.detail.open;
    if (open) setIsland(false);
    /* Recompute INMEDIATO de la visibilidad gated por el menú. El rAF tick (que setea la opacidad de
       #agcColorPill = islas de variantes, y de los hotspots del hero) se throttlea en tabs de fondo /
       Chrome automatizado → al cerrar el menú se quedaban en opacity:0 (bug Pedro 2026-07-13, "en page load").
       Lo resolvemos aquí en el evento, sin depender del loop. */
    evalHeroMode();
    placeToprail();   /* reposiciona el toprail (islas de variantes + 3D): su follow() rAF se congela bajo throttle → las islas quedaban "hasta abajo detrás del card" (Pedro 2026-07-13). */
    placeAnnBar();
    /* y otra vez cuando el card TERMINA su transición de cierre — el pase inmediato lo agarra a media
       animación (posición stale). setTimeout corre aunque el rAF esté throttled. */
    setTimeout(function () { placeToprail(); placeAnnBar(); }, 480);
    var blockPill = open || (island && island.classList.contains('open')) || root.classList.contains('scrolled') || root.classList.contains('cfg-open') || root.classList.contains('show-3d');
    if (colorPillEl) {
      colorPillEl.style.opacity = blockPill ? 0 : pillHeroVis;
      colorPillEl.style.pointerEvents = (!blockPill && pillHeroVis > 0.5) ? 'auto' : 'none';
    }
    if (heroHots) {
      var hh = open || root.classList.contains('cfg-open') || root.classList.contains('show-3d') || root.classList.contains('scrolled');
      heroHots.style.opacity = hh ? 0 : pillHeroVis;
      heroHots.style.visibility = (hh || pillHeroVis === 0) ? 'hidden' : 'visible';
    }
  });
  var menuBtn = $('#agcMenuBtn');
  if (menuBtn) menuBtn.addEventListener('click', function () {
    var willOpen = !nav.classList.contains('open');
    if (willOpen) setIsland(false);
    nav.classList.toggle('open', willOpen);
    navBg.classList.toggle('show', willOpen);
    root.classList.toggle('menu-open', willOpen);
    if (willOpen) startCycle(); else stopCycle();
  });
  if (navBg) navBg.addEventListener('click', closeMenu);

  /* ── reseñas: widget glass propio (datos de la BD) + vista Loox con fotos ── */
  var revOverlay = $('#agcReviewsOverlay');
  var REVIEWS = null, revShown = 0, revPhotosMode = false;
  var MESES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtRevDate(d) {
    if (!d) return '';
    var p = d.split('-');
    return (MESES[parseInt(p[1], 10) - 1] || '') + ' ' + parseInt(p[2], 10) + ', ' + p[0];
  }
  function revCard(rv) {
    var el = document.createElement('div');
    el.className = 'agc-revcard' + (rv.img ? ' has-img' : '');
    var stars = '★★★★★'.slice(0, rv.r) + '<span class="off">' + '★★★★★'.slice(rv.r) + '</span>';
    el.innerHTML =
      (rv.img ? '<div class="rc-img"><img loading="lazy" alt=""></div>' : '') +
      '<div class="rc-body">' +
      '<div class="rc-head"><span class="rc-name"></span>' +
      (rv.src === 'ml' ? '<span class="rc-verified rc-ml"><img src="' + CFG.reviewsUrl.replace(/agc-reviews\.json.*$/, 'agc-ml-logo.png') + '" alt="Verified" width="14" height="10" loading="lazy">Verified purchase</span>' : rv.v ? '<span class="rc-verified">✓ Verified</span>' : '') + '</div>' +
      '<div class="rc-meta"><span class="rc-stars">' + stars + '</span><span class="rc-date">' + fmtRevDate(rv.d) + '</span></div>' +
      '<p class="rc-text"></p></div>';
    if (rv.img) el.querySelector('.rc-img img').src = rv.img;
    el.querySelector('.rc-name').textContent = rv.n;
    el.querySelector('.rc-text').textContent = rv.t;
    return el;
  }
  var revFilter = 'all'; /* Todas / Con fotos / Sin fotos (Pedro 2026-07-14) */
  function revFiltered() {
    if (!REVIEWS) return [];
    if (revFilter === 'img') return REVIEWS.filter(function (r) { return !!r.img; });
    if (revFilter === 'txt') return REVIEWS.filter(function (r) { return !r.img; });
    return REVIEWS;
  }
  function renderRevBatch() {
    var grid = $('#agcRevGrid');
    if (!grid || !REVIEWS) return;
    var list = revFiltered();
    var frag = document.createDocumentFragment();
    list.slice(revShown, revShown + 18).forEach(function (rv) { frag.appendChild(revCard(rv)); });
    revShown = Math.min(revShown + 18, list.length);
    grid.appendChild(frag);
    var more = $('#agcRevMore');
    if (more) more.style.display = revShown >= list.length ? 'none' : '';
  }
  var revFilterBar = $('#agcRevFilter');
  if (revFilterBar) revFilterBar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-revf]');
    if (!b || b.classList.contains('on')) return;
    revFilter = b.getAttribute('data-revf');
    revFilterBar.querySelectorAll('.agc-revf-btn').forEach(function (x) { x.classList.toggle('on', x === b); });
    var grid = $('#agcRevGrid');
    if (grid) grid.innerHTML = '';
    revShown = 0;
    renderRevBatch();
  });
  function loadReviews() {
    if (REVIEWS) return;
    fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(function (d) {
      REVIEWS = d;
      renderRevBatch();
    }).catch(function () {
      /* sin datos: caer a la vista Loox */
      setPhotosMode(true);
    });
  }
  function setPhotosMode(on) {
    revPhotosMode = on;
    var sheet = revOverlay ? revOverlay.querySelector('.agc-reviews-sheet') : null;
    if (sheet) sheet.classList.toggle('photos', on);
    var btn = $('#agcRevPhotos');
    if (btn) btn.textContent = on ? '← Back to reviews' : 'See reviews with photos →';
  }
  /* Pedro 2026-06-22: si abre un modal del product card (reseñas / en acción) estando scrolleado fuera del above-the-fold, deslizar la página de regreso arriba — igual que "Comprar ahora". Así al cerrar el modal aterriza sobre el card, no varado en el objsec. No-op si no hay scroll. */
  function slideUpToCard() {
    /* "scrolleado fuera del above-the-fold" = ventana O scroller interno O clase scrolled (en embed scrollea la ventana, no el scroller; por eso revisamos ambos). */
    var wy = window.scrollY || window.pageYOffset || 0;
    var sy = scroller ? scroller.scrollTop : 0;
    if (wy < 40 && sy < 40 && !root.classList.contains('scrolled')) return false;
    try {
      if (window.__agcLenis) window.__agcLenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: 'smooth' });
      if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {}
    return true;
  }
  /* ── Cierre animado de overlays (Pedro 2026-07-13): la entrada anima con .show, pero quitar .show
     hacía display:none INSTANTÁNEO (cierre de fregadazo). .closing corre la animación inversa (CSS:
     salida ~60% de la duración de entrada, curva acelerada estilo Apple) y al terminar recién se esconde. ── */
  function animClose(ov) {
    if (!ov || !ov.classList.contains('show')) return;
    ov.classList.remove('show');
    ov.classList.add('closing');
    setTimeout(function () { ov.classList.remove('closing'); }, 440);   /* > salida más larga (.4s) */
  }
  var reviewsWasOpen = false;
  /* candado de documento para el modal de reseñas (Pedro 2026-07-03): la clase html.agc-sheet pierde contra
     el overflow:visible!important INLINE que pone el motor SMOOTH de la landing — se pelea inline vs inline
     (mismo patrón que el lockPage del boleto). Al cerrar se restaura visible!important si hay landing. */
  function revLockDoc(on) {
    var d = document.documentElement.style, b = document.body.style;
    if (on) { d.setProperty('overflow', 'hidden', 'important'); b.setProperty('overflow', 'hidden', 'important'); }
    else if (document.getElementById('agc-landing')) { d.setProperty('overflow', 'visible', 'important'); b.setProperty('overflow', 'visible', 'important'); }
    else { d.removeProperty('overflow'); b.removeProperty('overflow'); }
  }
  function openReviews() {
    closeMenu();
    /* si venía scrolleado: primero deslizamos de regreso al card, y abrimos el modal cuando llega arriba (~420ms). El modal bloquea el scroll, así que NO puede abrir antes del slide o lo congela. Pedro 2026-06-22 */
    var slid = slideUpToCard();
    var run = function () {
      reviewsWasOpen = islandOpen();   /* recuerda si el card estaba expandido para regresar igual al cerrar (Pedro 2026-06-21) */
      setIsland(false);
      if (revOverlay) { revOverlay.classList.remove('closing'); revOverlay.classList.add('show'); }
      document.documentElement.classList.add('agc-sheet'); /* esconde la barra compartida */
      revLockDoc(true);
      loadReviews();
    };
    if (slid) setTimeout(run, 420); else run();
  }
  function closeReviews() {
    animClose(revOverlay);
    document.documentElement.classList.remove('agc-sheet');
    revLockDoc(false);
    if (reviewsWasOpen) { setIsland(true); reviewsWasOpen = false; }   /* regresa al card expandido si así estaba */
  }
  var revMore = $('#agcRevMore');
  if (revMore) revMore.addEventListener('click', renderRevBatch);
  /* infinite scroll (Pedro 2026-07-03): el botón queda invisible como sentinel — al acercarse al fondo del modal dispara el mismo batch. Fallback: sin IntersectionObserver el botón se ve y funciona igual. */
  if (revMore && 'IntersectionObserver' in window) {
    revMore.classList.add('agc-rev-more--auto');
    var _revLastBatch = 0;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var now = Date.now();
        if (now - _revLastBatch < 280) return;   /* throttle: el fling rápido disparaba N batches → N re-layouts de la masonry (jank) */
        _revLastBatch = now;
        renderRevBatch();
      });
    }, { rootMargin: '600px 0px' }).observe(revMore);
  }
  var revWrite = $('#agcRevWrite');
  if (revWrite) revWrite.addEventListener('click', function () {
    if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') { try { window.LOOX.showReviewForm(); return; } catch (e) {} }
    setPhotosMode(true);
  });
  var revBtn = $('#agcReviewsBtn');
  if (revBtn) revBtn.addEventListener('click', openReviews);
  var menuRev = $('#agcMenuReviews');
  if (menuRev) menuRev.addEventListener('click', openReviews);
  var headRev = $('#agcHeadReviews');
  if (headRev) headRev.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  /* islas top (Pedro 2026-06-21): Vela en acción → modal de video (#agcVideoModal de theme.liquid); Ver reseñas → mismo widget */
  var velaIsle = $('#agcVelaIsle');
  /* Cierre del modal de video atado AQUÍ (Pedro 2026-07-22 URGENTE): el script de theme.liquid que
     ataba close/backdrop/Escape muere antes de correr por errores de scripts MX heredados (Kueski etc.)
     → el modal quedaba imposible de cerrar. Binding idempotente, independiente de theme.liquid. */
  function agcCloseVideo() {
    var m = document.getElementById('agcVideoModal'), p = document.getElementById('agcVideoPlayer');
    if (m) m.classList.remove('active');
    document.body.style.overflow = '';
    if (p) { try { p.pause(); p.currentTime = 0; } catch (e) {} }
  }
  function agcBindVideoClose() {
    var m = document.getElementById('agcVideoModal'), c = document.getElementById('agcVideoClose');
    if (!m || m.__agcCloseBound) return;
    m.__agcCloseBound = 1;
    if (c) c.addEventListener('click', function (e) { e.stopPropagation(); agcCloseVideo(); });
    m.addEventListener('click', function (e) { if (e.target === m) agcCloseVideo(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') agcCloseVideo(); });
  }
  if (velaIsle) velaIsle.addEventListener('click', function () {
    var slid = slideUpToCard();   /* mismo patrón que reseñas: desliza al card, abre el video cuando llega (Pedro 2026-06-22) */
    var run = function () {
      var m = document.getElementById('agcVideoModal'), p = document.getElementById('agcVideoPlayer');
      agcBindVideoClose();
      if (m) { m.classList.add('active'); document.body.style.overflow = 'hidden'; }
      if (p) { try { p.currentTime = 0; p.play(); } catch (e) {} }
    };
    if (slid) setTimeout(run, 420); else run();
  });
  var revIsle = $('#agcReviewsIsle');
  if (revIsle) revIsle.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  /* botón "Ver reseñas" dentro de la escena 7 del carrusel → mismo modal (Pedro 2026-06-24) */
  $$('[data-revbtn]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); openReviews(); }); });
  /* click en stars/puntuación → abre reseñas (Pedro 2026-06-21) */
  var priceStars = $('#agcPriceStars');
  if (priceStars) {
    priceStars.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
    priceStars.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReviews(); } });
  }
  var revClose = $('#agcReviewsClose');
  if (revClose) revClose.addEventListener('click', closeReviews);
  if (revOverlay) revOverlay.addEventListener('click', function (e) { if (e.target === revOverlay) closeReviews(); });

  /* === Modal "Problemas que atendemos" — mismo patrón slide-up que reseñas (Pedro 2026-06-26) === */
  var bnOverlay = $('#agcBenefitsOverlay');
  var benefitsWasOpen = false;
  function openBenefits() {
    closeMenu();
    var slid = slideUpToCard();   /* si venía scrolleado, regresa al card y abre cuando llega arriba */
    var run = function () {
      benefitsWasOpen = islandOpen();
      setIsland(false);
      if (bnOverlay) { bnOverlay.classList.remove('closing'); bnOverlay.classList.add('show'); }
      document.documentElement.classList.add('agc-sheet'); /* esconde la barra compartida */
    };
    if (slid) setTimeout(run, 420); else run();
  }
  function closeBenefits() {
    animClose(bnOverlay);
    document.documentElement.classList.remove('agc-sheet');
    if (benefitsWasOpen) { setIsland(true); benefitsWasOpen = false; }
  }
  var bnIsle = $('#agcBenefitsIsle');
  if (bnIsle) bnIsle.addEventListener('click', function (e) { e.stopPropagation(); openBenefits(); });
  var bnClose = $('#agcBenefitsClose');
  if (bnClose) bnClose.addEventListener('click', closeBenefits);
  /* tabs Cabello/Piel + acordeón single-open + cerrar al tocar el backdrop — todo delegado en el overlay */
  if (bnOverlay) bnOverlay.addEventListener('click', function (e) {
    if (e.target === bnOverlay) { closeBenefits(); return; }
    var tab = e.target.closest && e.target.closest('.agc-bn-tab');
    if (tab) {
      var key = tab.getAttribute('data-bntab');
      $$('#agcBenefitsOverlay .agc-bn-tab').forEach(function (x) { x.classList.toggle('on', x === tab); });
      $$('#agcBenefitsOverlay .agc-bn-panel').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-bnpanel') === key); });
      return;
    }
    var q = e.target.closest && e.target.closest('.agc-bn-q');
    if (q) {
      var item = q.parentNode, wasOpen = item.classList.contains('on');
      var panel = item.closest('.agc-bn-panel');
      if (panel) panel.querySelectorAll('.agc-bn-item.on').forEach(function (it) { it.classList.remove('on'); }); /* single-open por panel */
      if (!wasOpen) item.classList.add('on');
    }
  });

  /* ── hoja de objeciones: Chat (AI shell) ── */
  var askOverlay = $('#agcAskOverlay');
  var OBJ = [];
  try { var od = document.getElementById('agcObjData'); OBJ = od ? JSON.parse(od.textContent) : []; } catch (e) { OBJ = []; }
  var askChat = $('#agcAskChat');
  var typeTimer = null;

  /* FAQ-first: abre mostrando el FAQ (no el chat); el chat se revela on-demand (Pedro 2026-06-20) */
  /* scroll-lock a prueba de iOS: overflow:hidden NO frena el touch-scroll en Safari — body position:fixed con compensación de scrollY sí */
  var lockY = 0;
  function lockScroll(on) {
    var de = document.documentElement.style, bs = document.body.style;
    if (on) {
      lockY = window.scrollY || window.pageYOffset || 0;
      de.overflow = 'hidden';
      bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; bs.overflow = 'hidden';
    } else {
      de.overflow = '';
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
      window.scrollTo(0, lockY);
    }
  }
  function openAsk() { closeMenu(); setIsland(false); if (askOverlay) { askOverlay.classList.remove('closing'); askOverlay.classList.add('show'); } document.documentElement.classList.add('agc-sheet'); lockScroll(true); var b = $('#agcDudasBody'); if (b) b.classList.remove('chat-on'); var v = $('#agcAskVariants'); if (v) v.hidden = true; }
  function closeAsk() { animClose(askOverlay); document.documentElement.classList.remove('agc-sheet'); lockScroll(false); if (typeTimer) { clearInterval(typeTimer); typeTimer = null; } }
  /* Esc cierra el sheet (desktop) */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && askOverlay && askOverlay.classList.contains('show')) closeAsk(); });
  /* swipe-down sobre grab/header cierra el sheet (mobile) — umbral 70px, solo gesto descendente */
  (function () {
    var sheet = askOverlay && askOverlay.querySelector('.agc-ask-sheet'); if (!sheet) return;
    var y0 = null, dy = 0;
    [sheet.querySelector('.agc-ask-grab'), sheet.querySelector('.agc-ask-top')].forEach(function (z) {
      if (!z) return;
      z.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      z.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      z.addEventListener('touchend', function () {
        sheet.style.transition = ''; sheet.style.transform = '';
        if (dy > 70) closeAsk();
        y0 = null; dy = 0;
      });
    });
  })();
  /* accordion FAQ (un item abierto a la vez) */
  var faqWrap = $('#agcDudasFaq');
  if (faqWrap) faqWrap.addEventListener('click', function (e) {
    var q = e.target.closest('.agc-faq-q'); if (!q) return;
    var item = q.parentElement, wasOpen = item.classList.contains('open');
    faqWrap.querySelectorAll('.agc-faq-item.open').forEach(function (x) { x.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
  /* mini botón "Chatea con nosotros" → revela el chat existente (objection sheet) */
  var dudasChat = $('#agcDudasChat');
  if (dudasChat) dudasChat.addEventListener('click', function () {
    var b = $('#agcDudasBody'), v = $('#agcAskVariants');
    if (v) v.hidden = false;
    if (b) b.classList.add('chat-on');
    buildChat();
  });
  var dudasGo = $('#agcDudasGo'); if (dudasGo) dudasGo.addEventListener('click', agcGoConfig);
  var askBtn = $('#agcAskBtn'); if (askBtn) askBtn.addEventListener('click', openAsk);
  var askClose = $('#agcAskClose'); if (askClose) askClose.addEventListener('click', closeAsk);
  if (askOverlay) askOverlay.addEventListener('click', function (e) { if (e.target === askOverlay) closeAsk(); });
  var askAtc = $('#agcAskAtc'); if (askAtc) askAtc.addEventListener('click', agcGoConfig); /* Fase 2: ATC sticky → puente al configurador */

  /* — CHAT — */
  function scrollChat(log) { if (log) log.scrollTop = log.scrollHeight; }
  function typeText(el, text, log, done) {
    if (typeTimer) clearInterval(typeTimer);
    var words = text.split(' '), n = 0;
    typeTimer = setInterval(function () {
      el.textContent = words.slice(0, n + 1).join(' '); n++; scrollChat(log);
      if (n >= words.length) { clearInterval(typeTimer); typeTimer = null; if (done) done(); }
    }, 32);
  }
  /* — Fase 2: burbujas multi-beat · ATC sticky · resalte del siguiente chip · puente al configurador — */
  function splitAnswer(a) {
    var idx = a.indexOf('. ', 30);  /* primer punto tras char 30 → recon | resto */
    if (idx > 30 && idx < a.length - 25) return [a.slice(0, idx + 1), a.slice(idx + 2)];
    return [a];
  }
  function typeBubbles(parts, log, idx) {
    if (idx >= parts.length) return;
    var b = document.createElement('div'); b.className = 'agc-msg agc-msg-bot';
    b.innerHTML = '<div class="agc-msg-av">🌊</div><div class="agc-bubble"><span class="agc-typing"><i></i><i></i><i></i></span></div>';
    log.appendChild(b); scrollChat(log);
    setTimeout(function () {
      var bub = b.querySelector('.agc-bubble'); bub.textContent = '';
      typeText(bub, parts[idx], log, function () { typeBubbles(parts, log, idx + 1); });
    }, idx === 0 ? 600 : 380);
  }
  function revealAtc() {
    var foot = $('#agcAskFoot');
    if (foot && foot.hidden) { foot.hidden = false; requestAnimationFrame(function () { foot.classList.add('show'); }); }
  }
  function highlightNext() {
    var chips = $$('#agcChatChips .agc-chatchip');
    chips.forEach(function (c) { c.classList.remove('is-next'); });
    for (var j = 0; j < chips.length; j++) {
      if (!chips[j].classList.contains('used')) { chips[j].classList.add('is-next'); break; }
    }
  }
  /* puente: cierra el chat → expande la card → scroll al selector de tier con el default pre-resaltado */
  function agcGoConfig() {
    closeAsk();
    setMode('config');
    setTimeout(function () {
      var tiers = $('#agcTiers');
      if (tiers) {
        try { tiers.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        var def = tiers.querySelector('.agc-opt[data-tier="1"]') || tiers.querySelector('.agc-opt.on');
        if (def) { def.classList.add('agc-tierpulse'); setTimeout(function () { def.classList.remove('agc-tierpulse'); }, 1700); }
      }
    }, 700);
  }
  function chatAsk(i, chipEl) {
    var o = OBJ[i]; if (!o) return;
    var log = $('#agcChatLog'); if (!log) return;
    var u = document.createElement('div'); u.className = 'agc-msg agc-msg-user';
    u.innerHTML = '<div class="agc-bubble"></div>'; u.querySelector('.agc-bubble').textContent = o.q;
    log.appendChild(u);
    if (chipEl) chipEl.classList.add('used');
    revealAtc();                       /* ATC sticky desde la respuesta #1 */
    var chipsWrap = $('#agcChatChips');
    if (chipsWrap && !chipsWrap.querySelector('.agc-chatchip:not(.used)')) {
      chipsWrap.innerHTML = '<span class="agc-chat-chiplbl">The rest, you feel in your first shower 🌊</span>';
    } else { highlightNext(); }         /* resalta la siguiente pregunta lógica */
    scrollChat(log);
    typeBubbles(splitAnswer(o.a), log, 0);  /* respuesta en burbujas multi-beat */
  }
  function buildChat() {
    if (!askChat) return;
    if (typeTimer) { clearInterval(typeTimer); typeTimer = null; }
    var chips = OBJ.map(function (o, i) { return '<button class="agc-chatchip" data-i="' + i + '" type="button">' + o.c + '</button>'; }).join('');
    askChat.innerHTML =
      '<div class="agc-chat-log" id="agcChatLog">' +
        '<div class="agc-msg agc-msg-bot"><div class="agc-msg-av">🌊</div><div class="agc-bubble">No sales pitch here. Ask me whatever is actually holding you back — I will give it to you straight.</div></div>' +
      '</div>' +
      '<div class="agc-chat-chips" id="agcChatChips"><span class="agc-chat-chiplbl">Tap whatever is on your mind</span>' + chips + '</div>';
    askChat.querySelectorAll('.agc-chatchip').forEach(function (c) {
      c.addEventListener('click', function () { chatAsk(parseInt(c.getAttribute('data-i'), 10), c); });
    });
    /* resaltar el chip 1 (pregunta recomendada para empezar) + resetear el ATC sticky */
    var firstChip = askChat.querySelector('.agc-chatchip'); if (firstChip) firstChip.classList.add('is-next');
    var foot = $('#agcAskFoot'); if (foot) { foot.hidden = true; foot.classList.remove('show'); }
    /* 2ª burbuja de apertura, ~550ms después (ritmo humano) */
    setTimeout(function () {
      var log = $('#agcChatLog'); if (!log) return;
      var b = document.createElement('div'); b.className = 'agc-msg agc-msg-bot';
      b.innerHTML = '<div class="agc-msg-av">🌊</div><div class="agc-bubble">A lot of people show up with the same question. Tap yours 👇</div>';
      log.appendChild(b); scrollChat(log);
    }, 550);
  }

  /* ── ticker de confianza arriba del CTA: MANUAL (flechitas chicas), sin autoslide ── */
  (function () {
    var track = document.querySelector('#agcEta .agc-eta-track');
    if (!track) return;
    var msgs = track.children, n = msgs.length;
    if (n < 1) return;
    var idx = 0, EASE = 'transform .45s cubic-bezier(.65,0,.35,1)';
    function go(dir) {
      idx = (idx + dir + n) % n;
      var h = msgs[0].offsetHeight || 14;
      track.style.transition = EASE;
      track.style.transform = 'translateY(' + (-idx * h) + 'px)';
    }
    var prev = document.querySelector('#agcEta .agc-eta-arw.prev');
    var next = document.querySelector('#agcEta .agc-eta-arw.next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
  })();

  /* ── módulos flotantes DESKTOP: carrusel de reseñas (izq) + verdad minimal (arriba-der) ── */
  (function () {
    if (!document.querySelector('#agcDeskFloat')) return;
    var rail = $('#agcDfRevRail'), nextBtn = $('#agcDfRevNext'), mVerdad = $('#agcDfVerdad');
    var VERDAD = [];
    try { var vd = document.getElementById('agcVerdadData'); VERDAD = vd ? JSON.parse(vd.textContent) : []; } catch (e) { VERDAD = []; }

    /* RESEÑAS — carrusel INFINITO: todas las de Loox (imágenes primero), solo la izquierda se lee */
    var revPool = [], STEP = 316, revAnimating = false; /* card 300 + gap 16 */
    function buildRevCards(arr) {
      var ok = arr.filter(function (r) { return r.t && r.t.length > 20 && r.t.length < 240; });
      var withImg = ok.filter(function (r) { return !!r.img; });
      var noImg = ok.filter(function (r) { return !r.img; });
      revPool = withImg.concat(noImg); /* todas las con imagen primero, luego el resto (fondo sólido = sin perf hit) */
      if (!revPool.length) revPool = arr.slice();
      if (!rail) return;
      rail.innerHTML = '';
      revPool.forEach(function (rv) {
        var stars = '★★★★★'.slice(0, rv.r || 5);
        var card = document.createElement('div'); card.className = 'dfrev-card';
        card.innerHTML = '<div class="dfrev-top">' + (rv.img ? '<img class="dfrev-img" src="' + rv.img + '" alt="" loading="lazy">' : '') +
          '<div class="dfrev-id"><span class="dfrev-stars">' + stars + '</span><span class="dfrev-name"></span></div></div>' +
          '<p class="dfrev-text"></p>';
        card.querySelector('.dfrev-name').textContent = rv.n + (rv.v ? '  ·  ✓' : '');
        card.querySelector('.dfrev-text').textContent = '“' + rv.t + '”';
        rail.appendChild(card);
      });
    }
    /* avance infinito: anima -1 card, luego mueve la 1ª al final y resetea sin transición (sin saltos, sin fin) */
    function advanceRev() {
      if (revPool.length < 2 || !rail || revAnimating) return;
      revAnimating = true;
      rail.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      rail.style.transform = 'translateX(' + (-STEP) + 'px)';
      var fired = false;
      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== 'transform') return;
        if (fired) return; fired = true;
        clearTimeout(fb);
        rail.removeEventListener('transitionend', done);
        rail.style.transition = 'none';
        if (rail.firstElementChild) rail.appendChild(rail.firstElementChild);
        rail.style.transform = 'translateX(0)';
        void rail.offsetWidth; /* fuerza reflow para que el siguiente avance vuelva a animar */
        revAnimating = false;
      };
      rail.addEventListener('transitionend', done);
      var fb = setTimeout(done, 720); /* fallback si transitionend no dispara */
    }
    if (nextBtn) nextBtn.addEventListener('click', advanceRev);
    if (typeof REVIEWS !== 'undefined' && REVIEWS) buildRevCards(REVIEWS);
    else fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(buildRevCards).catch(function () {});
    setInterval(function () { advanceRev(); }, 7000);

    /* VERDAD — detalle minimal arriba a la derecha, rota suave */
    if (mVerdad && VERDAD.length) {
      mVerdad.innerHTML = '<span class="dfv-eyebrow">The water you don\'t see</span><p class="dfv-text"></p>';
      var vEl = mVerdad.querySelector('.dfv-text'), verIdx = 0;
      vEl.textContent = VERDAD[0];
      setInterval(function () {
        verIdx++;
        vEl.style.opacity = '0';
        setTimeout(function () { vEl.textContent = VERDAD[verIdx % VERDAD.length]; vEl.style.opacity = '1'; }, 600);
      }, 5500);
    }
  })();

  /* ── modelo 3D real (model-viewer): toggle Ver Filtro / Ver Tecnología (estilo iyo) ── */
  (function () {
    var mv = $('#agcMv'), stage = $('#agc3d');
    var toggle = $('#agcViewToggle'), dock = $('#agcViewDock'), hint = $('#agc3dHint');
    if (!mv || !stage || !toggle) return;
    var MODELS = CFG.models3d || {};
    var active = false, subMode = 'normal', loadedColor = null, raf = null, hintTimer = null;

    function showHint() {
      if (!hint) return;
      hint.classList.remove('show'); void hint.offsetWidth; hint.classList.add('show');
      if (hintTimer) clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hint.classList.remove('show'); }, 4200);
    }
    function hideHint() { if (hint) hint.classList.remove('show'); if (hintTimer) { clearTimeout(hintTimer); hintTimer = null; } }
    mv.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') hideHint(); });

    function cancelAnims() { if (raf) cancelAnimationFrame(raf); raf = null; }
    function watchUntil(stopAt, after) {
      cancelAnimationFrame(raf);
      var w = function () { if (mv.currentTime >= stopAt - 0.03) { mv.pause(); after && after(); return; } raf = requestAnimationFrame(w); };
      raf = requestAnimationFrame(w);
    }
    /* auto-rotate (built-in) da la vida en reposo; se pausa al tocar y se reanuda tras el delay */
    function autoRotate(on) { if (on) mv.setAttribute('auto-rotate', ''); else mv.removeAttribute('auto-rotate'); }
    function closeHots() { mv.querySelectorAll('.agc-hot.open').forEach(function (h) { h.classList.remove('open'); }); }
    /* modelo normal cerrado — gira/zoom libre + auto-rotate idle */
    function showNormal() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.pause();
      mv.cameraTarget = '0m -0.05m 0m'; mv.cameraOrbit = '38deg 60deg 1.08m'; autoRotate(true);
    }
    function playFiltro() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '0m -0.14m 0m'; mv.cameraOrbit = '28deg 80deg 1.2m'; autoRotate(false);
      mv.play(); watchUntil(2.5, function () { mv.pause(); autoRotate(true); });
    }
    function playTech() {
      cancelAnims(); mv.setAttribute('shadow-intensity', '0');
      try { mv.animationName = 'tecnologia'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '-0.004m -0.135m 0m'; mv.cameraOrbit = '40deg 86deg 0.92m'; autoRotate(false);
      mv.play(); watchUntil(2.3, function () { mv.pause(); mv.classList.add('tech'); if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); autoRotate(false); });  /* zoom in + queda FIJA en la posición centrada (ref Pedro); el usuario gira manual si quiere */
    }
    function applySub() { if (subMode === 'filtro') playFiltro(); else if (subMode === 'tech') playTech(); else showNormal(); }
    /* SPEED: model-viewer se carga LAZY on-tap del 3D (self-host), no eager. Compartido vía customElements + window.__mvP (idempotente, también lo reusa el showcase del landing). */
    function ensureMV(cb) {
      if (window.customElements && customElements.get('model-viewer')) { cb && cb(); return; }
      if (!window.__mvP) { window.__mvP = new Promise(function (res) { var sc = document.createElement('script'); sc.type = 'module'; sc.src = CFG.mvUrl; sc.onload = res; sc.onerror = res; document.head.appendChild(sc); }); }
      window.__mvP.then(function () { cb && cb(); });
    }
    var pendingOnLoad = null;
    function ensureModel(cb) {
      var key = state.colorKey;                 /* fija el color pedido AHORA, no el que esté activo al disparar load */
      var url = MODELS[key];
      if (!url) { cb && cb(); return; }
      /* ya cargado Y el src actual ES el de este color → listo (antes faltaba el check de src → falso early-return mid-swap) */
      if (loadedColor === key && mv.loaded && mv.getAttribute('src') === url) { cb && cb(); return; }
      /* descarta cualquier listener pendiente de un color anterior (evita doble-fire / loadedColor stale al switchear rápido) */
      if (pendingOnLoad) { mv.removeEventListener('load', pendingOnLoad); pendingOnLoad = null; }
      var onLoad = function () { mv.removeEventListener('load', onLoad); pendingOnLoad = null; loadedColor = key; cb && cb(); };
      pendingOnLoad = onLoad;
      if (mv.getAttribute('src') !== url) { mv.addEventListener('load', onLoad); mv.src = url; }
      else if (mv.loaded) { pendingOnLoad = null; loadedColor = key; cb && cb(); }
      else { mv.addEventListener('load', onLoad); }
    }
    function setToggle() { toggle.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-view') === (active ? '3d' : '2d')); }); }
    function setDock() { if (!dock) return; dock.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', active && b.getAttribute('data-mode') === subMode); }); }
    function open3d() {
      if (active) return;
      active = true; subMode = 'normal';
      root.classList.add('show-3d'); closeMenu(); setIsland(false);
      stage.hidden = false; requestAnimationFrame(function () { stage.classList.add('show'); });
      showHint();
      setToggle(); setDock(); ensureMV(function () { ensureModel(applySub); });
      requestAnimationFrame(function () { requestAnimationFrame(placeToprail); });   /* pega el toprail al viewdock (Pedro 2026-06-22) */
      /* SPEED/UX: en vista 3D, bloquear el scroll de página (no scrollear a la historia). */
      var d3 = document.documentElement, b3 = document.body;
      d3.style.setProperty('overflow', 'hidden', 'important'); b3.style.setProperty('overflow', 'hidden', 'important');
    }
    function close3d() {
      active = false; subMode = 'normal'; cancelAnims(); mv.classList.remove('tech'); closeHots(); hideHint();
      root.classList.remove('show-3d'); stage.classList.remove('show');
      if (document.getElementById('agc-landing')) { var d3=document.documentElement, b3=document.body; d3.style.setProperty('overflow', 'visible', 'important'); b3.style.setProperty('overflow', 'visible', 'important'); }
      setTimeout(function () { if (!active) stage.hidden = true; }, 560);
      setToggle(); setDock();
      requestAnimationFrame(placeToprail);   /* vuelve a anclar el toprail arriba del card al salir de 3D (Pedro 2026-06-22) */
    }
    function setSub(m) {
      if (!active || subMode === m) return;   /* selección directa (Modelo / Filtro / Tecnología) */
      subMode = m;
      setDock(); applySub();
    }
    toggle.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('data-view') === '3d') open3d(); else close3d(); });
    });
    if (dock) dock.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { setSub(b.getAttribute('data-mode')); });
    });
    /* tap-to-reveal: tocar un dot revela su nombre y cierra los demás */
    mv.querySelectorAll('.agc-hot').forEach(function (h) {
      h.addEventListener('click', function (e) { e.stopPropagation(); var was = h.classList.contains('open'); closeHots(); if (!was) h.classList.add('open'); });
    });
    window.__agc3dSync = function () { if (active) ensureModel(applySub); };
    /* salir del 3D al abrir la card (reset de fondo a imagen) — close3d NO toca la isla */
    window.__agc3dExit = function () { if (active) close3d(); };
  })();

  /* ── interacción isla (CTA de dos tiempos: Comprar ahora → expandir → Agregar) ── */
  var island = $('#agcIsland');
  function islandOpen() { return island.classList.contains('open'); }
  function inCart() { return island.classList.contains('cart'); }
  /* modos: 'collapsed' | 'config' | 'cart' */
  /* Announcement bar: en CONFIG se reposiciona arriba del card (que es bottom-anchored → su bottom es estable)
     con fondo oscuro; en COLLAPSED vuelve arriba (CSS top:72); en CART el CSS lo esconde. */
  var annRaf;
  /* ── Reseñas: centra el card glass en la banda libre entre el techo y la última isla (annbar/card).
     Si no cabe (espacio < altura del card) → NO se muestra (clase agc-rev-fits). Pedro 2026-06-27 ── */
  function placeRevZone() {
    var zone = $('#agcRevTkr'); if (!zone) return;
    var off = !island.classList.contains('open')
      || root.classList.contains('cart-mode')
      || root.classList.contains('agc-step-color')
      || root.classList.contains('show-3d')
      || root.classList.contains('menu-open')
      || root.classList.contains('scrolled')
      || document.documentElement.classList.contains('agcn-open');
    if (off) { zone.classList.remove('agc-rev-fits'); zone.style.top = ''; return; }
    var bar = $('#agcAnnBar');
    var lower = (bar && bar.getBoundingClientRect().height > 4) ? bar : island;
    var floor = lower.getBoundingClientRect().top - 12;          /* arriba de la última isla */
    var CEIL = 54;                                               /* techo (bajo el status bar) */
    var card = zone.querySelector('.agc-revcard');
    var cardH = (card ? card.offsetHeight : 96) + 16;            /* + cola de los ghosts */
    var avail = floor - CEIL;
    if (avail < cardH + 8) {                                     /* no cabe → ocúltalo */
      zone.classList.remove('agc-rev-fits'); zone.style.top = '';
    } else {
      zone.classList.add('agc-rev-fits');
      zone.style.top = Math.round(CEIL + (avail - cardH) / 2) + 'px';   /* centrado vertical */
    }
  }

  function placeAnnBar() {
    var bar = $('#agcAnnBar'); if (!bar) return;
    cancelAnimationFrame(annRaf);
    if (root.classList.contains('cart-mode')) { placeRevZone(); return; } /* en cart lo esconde el CSS */
    if (island.classList.contains('open')) {
      /* config: el annbar SIGUE al card (que se expande con transición) → aparece al instante y
         sube con él. Anclado 12px arriba del card y CENTRADO SOBRE EL CARD (no sobre la pantalla)
         → en desktop el card está a la derecha, así el annbar queda encima de él. Fondo oscuro. */
      bar.classList.add('is-oncard');
      bar.style.top = 'auto';
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      (function follow() {
        var r = island.getBoundingClientRect();
        bar.style.left = Math.round(r.left + r.width / 2) + 'px';
        bar.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
        placeRevZone();   /* recoloca las reseñas mientras el card se expande */
        var now = (window.performance && performance.now) ? performance.now() : Date.now();
        if (now - t0 < 1000) annRaf = requestAnimationFrame(follow); /* sigue durante la transición (~.85s) */
      })();
    } else {
      /* collapsed: vuelve arriba (CSS top:72, centrado en pantalla) */
      bar.style.top = ''; bar.style.bottom = ''; bar.style.left = '';
      bar.classList.remove('is-oncard');
      placeRevZone();
    }
  }
  window.addEventListener('resize', placeAnnBar);
  /* toprail (color pills + toggle 3D) anclado ARRIBA del product card en colapsado (Pedro 2026-06-21) */
  var trRaf;
  function placeToprail() {
    var tr = $('#agcTopRail'); if (!tr) return;
    cancelAnimationFrame(trRaf);
    if (root.classList.contains('cart-mode') || island.classList.contains('open')) return;
    /* 3D: el toprail se PEGA al viewdock (Modelo/Filtro/Tech); colapsado: arriba del card (Pedro 2026-06-22) */
    var in3d = root.classList.contains('show-3d');
    var anchorEl = in3d ? $('#agcViewDock') : island;
    if (!anchorEl) return;
    var gap = in3d ? 7 : 12;
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    tr.style.transition = 'none';   /* SMOOTH: seguir el card por TRANSFORM (compositado), sin la transición CSS que mete lag. Pedro 2026-06-23 */
    (function follow() {
      if (island.classList.contains('open')) { tr.style.transition = ''; return; }
      var r = anchorEl.getBoundingClientRect();
      tr.style.top = '0px'; tr.style.bottom = 'auto'; tr.style.left = '0px';
      /* translate3d → GPU, no dispara layout. En mobile el GRUPO COMPLETO (píldora+cubo + ambas flechas a la derecha) se centra como unidad sobre el ancla (Pedro 2026-07-06: "todas las islas centradas"). */
      var railY = Math.round(r.top - gap - tr.offsetHeight);
      var railX = Math.round(r.left + r.width / 2 - tr.offsetWidth / 2);
      if (window.innerWidth < 900) {
        var aP = document.getElementById('agcHeroArrowPrev'), aN = document.getElementById('agcHeroArrow');
        if (aP && aN) {
          var extra = 8 + aP.offsetWidth + 8 + aN.offsetWidth;   /* ‹ y › van a la derecha del rail */
          railX = Math.round(r.left + r.width / 2 - (tr.offsetWidth + extra) / 2);   /* centrar píldora+cubo+flechas como un solo grupo */
          var arrL = railX + tr.offsetWidth + 8, arrR = arrL + aP.offsetWidth + 8;
          var over = (arrR + aN.offsetWidth) - (window.innerWidth - 4);
          if (over > 0) { railX -= over; arrL -= over; arrR -= over; }
          if (railX < 4) { var d = 4 - railX; railX += d; arrL += d; arrR += d; }
          var cy = railY + tr.offsetHeight / 2 - aP.offsetHeight / 2;
          aP.style.right = 'auto'; aP.style.left = arrL + 'px'; aP.style.top = cy + 'px'; aP.style.transform = 'none';
          aN.style.right = 'auto'; aN.style.left = arrR + 'px'; aN.style.top = cy + 'px'; aN.style.transform = 'none';
        }
      }
      tr.style.transform = 'translate3d(' + railX + 'px,' + railY + 'px,0)';
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - t0 < 800) trRaf = requestAnimationFrame(follow);
      else tr.style.transition = '';   /* restaurar la transición para el open/close */
    })();
  }
  window.addEventListener('resize', placeToprail);
  requestAnimationFrame(function () { requestAnimationFrame(placeToprail); });
  function setMode(mode) {
    if (mode !== 'collapsed' && window.__agc3dExit) window.__agc3dExit();  /* abrir card → fondo vuelve a imagen */
    island.classList.toggle('open', mode !== 'collapsed');
    island.classList.toggle('cart', mode === 'cart');
    root.classList.toggle('cfg-open', mode !== 'collapsed');
    root.classList.toggle('cart-mode', mode === 'cart');
    document.documentElement.classList.toggle('agc-cfgopen', mode !== 'collapsed'); /* barra compartida se oculta al expandir la card */
    /* En el cart: bloquear el scroll de página (no scrollear a la historia embebida) + subir al tope para que el cart se vea.
       El scroll INTERNO del cart (.agc-cartscroll) sigue funcionando. Sale del cart → restaura el scroll de documento. */
    var d = document.documentElement, b = document.body;
    if (mode === 'cart') {
      window.scrollTo(0, 0);
      d.style.setProperty('overflow', 'hidden', 'important'); b.style.setProperty('overflow', 'hidden', 'important');
    } else if (document.getElementById('agc-landing') && !root.classList.contains('show-3d') && !document.documentElement.classList.contains('agc-sheet')) {
      /* agc-sheet = modal de reseñas abierto → NO restaurar el scroll del documento (Pedro 2026-07-03: el modal debe bloquear la landing) */
      d.style.setProperty('overflow', 'visible', 'important'); b.style.setProperty('overflow', 'visible', 'important');
    }
    /* EL BOLETO (Pedro 2026-07-02): la 1ª vez que abren la card en la sesión, el step Atínale va antes de los deal cards */
    if (mode === 'config' && window.__agcMunMaybeOpen) window.__agcMunMaybeOpen();
    /* transición de modo top-level → siempre arranca en el paso 'config' (no atorar en color step) */
    state.step = 'config';
    root.classList.remove('agc-step-color');
    root.classList.remove('agc-step-care');
    updateCta();
    placeAnnBar();
    placeToprail();
    if (window.__agcPlacePromo) window.__agcPlacePromo();
  }
  function setIsland(open) { setMode(open ? 'config' : 'collapsed'); }
  /* TEST (Pedro 2026-06-24): tras elegir color, el CTA va DIRECTO a checkout (no abre el cart). El cart NO se elimina — solo se omite este paso por mientras. Revert = false. */
  var CTA_DIRECT_CHECKOUT = true;
  /* CTA con crossfade de copy (transición Apple) */
  function setCtaLabel(html) {
    var label = $('#agcCtaLabel');
    if (!label) return;
    if (label.dataset.cur === html) { return; }
    label.dataset.cur = html;
    label.style.transition = 'opacity .18s ease';
    label.style.opacity = '0';
    setTimeout(function () { label.innerHTML = html; if (!inCart()) render(); label.style.opacity = '1'; }, 180);
  }
  function updateCta() {
    var btn = $('#agcAddBtn');
    /* color por estado: comprar=negro · agregar=verde · finalizar=beige (espejo del menu drawer) */
    function ctaTone(t) { if (!btn) return; btn.classList.remove('cta-add', 'cta-checkout'); if (t) btn.classList.add(t); }
    if (btn) btn.classList.remove('cta-elegir');   /* reset flechita del paso "Elegir mi acabado" (Pedro 2026-06-21) */
    if (inCart()) { if (btn) btn.classList.remove('is-soldout'); ctaTone('cta-checkout'); setCtaLabel('Check out'); return; }
    /* el ATC se inhabilita SOLO con la card abierta y color agotado; "Comprar ahora" nunca se bloquea */
    if (islandOpen() && colorSoldOut()) {
      if (btn) btn.classList.add('is-soldout');
      ctaTone(null);
      setCtaLabel('Sold out&nbsp;&nbsp;→&nbsp;&nbsp;Pick another finish');
      return;
    }
    if (btn) btn.classList.remove('is-soldout');
    /* Opción A CRO: negro constante en comprar + agregar; el color (verde=go) se reserva para el checkout */
    if (islandOpen()) {
      ctaTone(null);
      if (state.step === 'config') { if (btn) btn.classList.add('cta-elegir'); setCtaLabel(state.tier === 1 ? 'Choose my finish' : 'Choose my finishes'); }  /* + flechita vía .cta-elegir (Pedro 2026-06-21) */
      else setCtaLabel(CTA_DIRECT_CHECKOUT ? 'CHECKOUT&nbsp;&nbsp;→' : 'Add to cart');   /* paso finishes: CHECKOUT + flecha (Pedro 2026-07-23) */
    }
    else { ctaTone(null); setCtaLabel('GO ZERO NOW.'); }   /* colapsado: CTA de compra (Pedro 2026-06-21) */
  }
  $('#agcCfgRow').addEventListener('click', function () {
    closeMenu();
    setMode(islandOpen() ? 'collapsed' : 'config');
  });
  /* #B — la flecha "regresar" del cart VACÍA el carrito (asumimos que quiere reconfigurar desde cero) */
  var cartBack = $('#agcCartBack');
  if (cartBack) cartBack.addEventListener('click', function () {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { state.tier = 1; setMode('config'); if (typeof refreshCount === 'function') refreshCount(); })
      .catch(function () { setMode('config'); });
  });
  /* "Seguir comprando" del estado vacío → vuelve a configurar (sin tocar el carrito) */
  var emptyCta = $('#agcCartEmptyCta');
  if (emptyCta) emptyCta.addEventListener('click', function () { state.tier = 1; setMode('config'); });

  /* Volver arriba con el product card EXPANDIDO — usado por el CTA glass Y por el loop de scroll infinito. */
  window.AGCReturnToConfig = function () {
    if (window.__agcLenis) window.__agcLenis.scrollTo(0); else window.scrollTo({ top: 0, behavior: 'smooth' });
    if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
    setMode('config');
  };
  /* CTA glass "Configurar": aparece al perder de vista el product card (scroll a la historia embebida). */
  var backTopBtn = document.getElementById('agcBackTop');
  /* Loop "scroll infinito": al llegar al fondo de la historia (donde estaba el showcase removido),
     regresa al configurador. Guard de settle (no pelea con el momentum: solo al borde mismo). */
  var loopArmed = false, loopT = 0;
  if (backTopBtn) {
    var btRaf = 0;
    function btUpd() {
      btRaf = 0;
      var y = window.scrollY || window.pageYOffset || 0;
      backTopBtn.classList.toggle('show', y > innerHeight * 0.6);
      /* borde inferior: el usuario llegó al final → re-arma y, tras settle, hace loop al configurador */
      var atBottom = (y + innerHeight) >= (document.documentElement.scrollHeight - 6);
      if (atBottom) {
        if (!loopArmed) {
          loopArmed = true;
          clearTimeout(loopT);
          loopT = setTimeout(function () { if (loopArmed) { loopArmed = false; window.AGCReturnToConfig(); } }, 420);
        }
      } else { loopArmed = false; clearTimeout(loopT); }
    }
    window.addEventListener('scroll', function () { if (!btRaf) btRaf = requestAnimationFrame(btUpd); }, { passive: true });
    btUpd();
    backTopBtn.addEventListener('click', function () { window.AGCReturnToConfig(); });
  }
  /* islas FIJAS (annbar/toprail/promobar position:fixed): en embed la ventana scrollea, así que las ocultamos al pasar la 1ª pantalla (Pedro 2026-06-20) */
  (function () {
    var ir = 0;
    function iupd() { ir = 0; var _sy = (window.scrollY || window.pageYOffset || 0); root.classList.toggle('agc-isle-gone', _sy > innerHeight * 0.5); root.classList.toggle('agc-tr-gone', _sy > 28 || (scroller && scroller.scrollTop > 28)); /* Pedro 2026-06-25: el toprail se VA apenas scrollean (umbral 28px, cualquier scroll), no a la mitad — "luego luego se van con el scroll". Estático (sin follow). */ }
    window.addEventListener('scroll', function () { if (!ir) ir = requestAnimationFrame(iupd); }, { passive: true });
    iupd();
  })();
  /* hook para el basket del nav (.agcn-cartbtn): el onclick inline del snippet llama AGCNavCart() → abre el cart-morph, no navega a /cart */
  window.AGCNavCart = function () {
    getCart().then(function (cart) {
      /* renderCart maneja el caso vacío (muestra el empty state con "Seguir comprando"),
         así que SIEMPRE abrimos el cart — con items o vacío, como el cart live. */
      renderCart(cart); loadTapeteSheet(); setMode('cart'); startCartBar();
    }).catch(function () {
      /* fetch falló (sin red / in-app browser): abrir el morph IGUAL (vacío o último cacheado) en vez de navegar fuera (Pedro 2026-06-20) */
      try { renderCart(LASTCART || { items: [], item_count: 0, total_price: 0, items_subtotal_price: 0, original_total_price: 0, total_discount: 0, currency: 'MXN' }); loadTapeteSheet(); setMode('cart'); startCartBar(); } catch (e) {}
    });
    return true;
  };

  /* #7 — Modal Aguacero Care al finalizar pedido. Regla del cart LIVE: aparece SOLO si hay Ducha y NO hay Care (sin localStorage).
     id/clase renombrados a agcCfgCare* / .agc-cfg-care-* → 0 colisión con el #agcCareOverlay global de cart-drawer.liquid.
     El nodo se MUEVE a <body> en init: lo inmuniza del foster-parenting del parser y del CSS scopeado a #agc-cfg
     (el CSS de este overlay es standalone, posición fixed, vive donde viva). */
  var careOverlay = (function () {
    var ov = document.getElementById('agcCfgCareOverlay');
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov); /* idempotente: si ya está en body, no-op */
    return ov;
  })();
  function checkoutOrCare() {
    getCart().then(function (cart) {
      var hasCare = cart.items.some(function (i) { return i.variant_id === CC.careVariant || i.variant_id === CC.careGiftVariant; });
      var hasDucha = cart.items.some(function (i) { return i.product_id === CFG.duchaProductId && i.original_price !== 0; });
      if (hasCare || !hasDucha) { window.location.href = '/checkout'; return; }
      var ov = careOverlay || document.getElementById('agcCfgCareOverlay');
      if (!ov) { window.location.href = '/checkout'; return; }
      ov.classList.remove('closing'); ov.classList.add('show'); ov.setAttribute('aria-hidden', 'false');
    }).catch(function () { window.location.href = '/checkout'; });
  }
  (function () {
    var ov = careOverlay; if (!ov) return;
    function closeCare() { animClose(ov); ov.setAttribute('aria-hidden', 'true'); }
    var yes = ov.querySelector('#agcCfgCareYes'), no = ov.querySelector('#agcCfgCareNo');
    if (yes) yes.addEventListener('click', function () {
      yes.disabled = true; yes.textContent = 'Adding…';
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
    if (no) no.addEventListener('click', function () { window.location.href = '/checkout'; });
    var x = ov.querySelector('#agcCfgCareX'); if (x) x.addEventListener('click', closeCare); /* X arriba-izq → cerrar (si vuelven de checkout y el modal quedó abierto) */
    ov.addEventListener('click', function (e) { if (e.target === ov) closeCare(); }); /* backdrop → cerrar, quedarse en cart */
  })();

  $('#agcTiers').addEventListener('click', function (e) {
    var o = e.target.closest('.agc-opt'); if (!o) return;
    $$('.agc-opt[data-tier]').forEach(function (x) { x.classList.remove('on'); });
    o.classList.add('on');
    state.tier = +o.dataset.tier;
    ensureColorsLen(); /* ajusta colores por ducha al nuevo tier */
    render();
    updateCta();   /* refresca "Elegir mi acabado" ↔ "Elegir mis acabados" según tier (Pedro 2026-06-21) */
    requestAnimationFrame(placeAnnBar);   /* el card cambia de altura con el tier → reanclar annbar y ocultar la reseña si ya no cabe (Pedro 2026-07-03) */
  });

  /* cambio de color compartido (isla + color pill) — agotados SÍ seleccionables */
  function colorSoldOut() { var c = colorByKey(state.colorKey); return c && !c.available; }
  function selectColor(key) {
    var c = colorByKey(key);
    if (!c) return;
    state.colorKey = key;
    syncThumb();              /* actualiza thumb + .on de las swatches de la isla */
    setHeroColor(key);        /* swap del strip + tinte SIN reiniciar la animación */
    /* paso "elegir color": galería del producto en el color elegido (lazy: solo carga estando en el paso) */
    if (root.classList.contains('agc-step-color')) { var _ei = $('#agcElegirImg'); if (_ei && CFG.elegirStrips && CFG.elegirStrips[key] && _ei.getAttribute('src') !== CFG.elegirStrips[key]) _ei.src = CFG.elegirStrips[key]; }
    render();
    $$(".agc-cpsw").forEach(function (x) { x.classList.toggle("on", x.dataset.c === key); });
    syncSoldPill();
    updateCta();
    if (window.__agc3dSync) window.__agc3dSync();   /* si el 3D está activo, recargar el GLB del color */
  }
  /* pickers GLOBALES (swatches + toprail pill) = color maestro → propaga a todas las duchas para que el color step lo herede (Pedro 2026-06-21) */
  function setGlobalColor(key) { selectColor(key); for (var i = 0; i < state.colors.length; i++) state.colors[i] = key; }
  $('#agcSwatches').addEventListener('click', function (e) {
    var s = e.target.closest('.agc-sw'); if (!s) return;
    setGlobalColor(s.dataset.c);
  });
  var colorPill = $('#agcColorPill');
  if (colorPill) colorPill.addEventListener('click', function (e) {
    var b = e.target.closest('.agc-cpsw'); if (!b) return;
    setGlobalColor(b.dataset.c);
  });

  /* ═══ Paso de color POR DUCHA (T2/T3) — Pedro 2026-06-21 ═══ */
  function colorByVariant(vid) {
    for (var i = 0; i < CFG.colors.length; i++) { if (Number(CFG.colors[i].variantId) === Number(vid)) return CFG.colors[i]; }
    return null;
  }
  function firstColorKey() { return (CFG.colors.filter(function (x) { return x.available; })[0] || CFG.colors[0]).key; }
  /* mantiene state.colors con largo = tier; rellena nuevas con el 1er color */
  function ensureColorsLen() {
    var fk = firstColorKey();
    if (!state.colors.length) state.colors = [fk];
    while (state.colors.length < state.tier) state.colors.push(fk);
    if (state.colors.length > state.tier) state.colors = state.colors.slice(0, state.tier);
  }
  function _csColorName(k) { return ((colorByKey(k) || {}).name || ''); }   /* nombre real completo (Pedro 2026-07-23) */
  function _csSwatches(rowAttr, selKey) {
    var h = '';
    for (var i = 0; i < CFG.colors.length; i++) {
      var col = CFG.colors[i];
      var on = col.key === selKey ? ' on' : '';
      var so = col.available ? '' : ' soldout';
      h += '<div class="agc-cssw' + on + so + '" data-row="' + rowAttr + '" data-c="' + col.key + '"><img src="' + (col.img || '') + '" alt="" loading="lazy"><span>' + (col.name.split(' ')[0]) + '</span></div>';
    }
    return h;
  }
  /* T2/T3: por default UNA fila global (92% pide todas iguales — data 2026-06). Toggle opt-in para colores distintos por ducha (el 8%). Pedro 2026-06-27 */
  function buildColorStepRows() {
    ensureColorsLen();
    var host = $('#agcColorStepRows'); if (!host) return;
    var title = $('#agcColorStepTitle');
    var html = '';
    if (state.tier === 1) {
      if (title) title.textContent = 'Which finish do you want?';
      html = '<div class="agc-csrow" data-row="0"><div class="agc-csrow-lb">Your shower: <span class="agc-csrow-c">' + _csColorName(state.colors[0]) + '</span></div><div class="agc-csrow-sw">' + _csSwatches('0', state.colors[0]) + '</div></div>';
    } else if (!state.colorPerDucha) {
      if (title) title.textContent = 'Which finish do you want?';
      var allSame = state.colors.slice(0, state.tier).every(function (k) { return k === state.colors[0]; });
      var tgOn = '<button type="button" class="agc-csperducha" data-perducha="on">Different finish<span class="agc-cspd-chev" aria-hidden="true">›</span></button>';
      html = '<div class="agc-csrow" data-row="all"><div class="agc-csrow-lb"><span class="agc-csrow-t">Your ' + state.tier + ' showers: <span class="agc-csrow-c">' + (allSame ? _csColorName(state.colors[0]) : 'mixed') + '</span></span>' + tgOn + '</div><div class="agc-csrow-sw">' + _csSwatches('all', allSame ? state.colors[0] : null) + '</div></div>';
    } else {
      if (title) title.textContent = 'A finish for each shower?';
      var tgOff = '<button type="button" class="agc-csperducha" data-perducha="off">Same finish<span class="agc-cspd-chev" aria-hidden="true">›</span></button>';
      for (var n = 0; n < state.tier; n++) {
        html += '<div class="agc-csrow" data-row="' + n + '"><div class="agc-csrow-lb"><span class="agc-csrow-t">Shower ' + (n + 1) + ': <span class="agc-csrow-c">' + _csColorName(state.colors[n]) + '</span></span>' + (n === 0 ? tgOff : '') + '</div><div class="agc-csrow-sw">' + _csSwatches('' + n, state.colors[n]) + '</div></div>';
      }
    }
    host.innerHTML = html;
  }
  function setStep(step) {
    state.step = step;
    root.classList.toggle('agc-step-color', step === 'color');
    root.classList.toggle('agc-step-care', step === 'care');
    if (step === 'color') {
      buildColorStepRows(); selectColor(state.colors[0]);
      /* cada vez que entran al paso color, el plan se resetea a Plus+ (default). Si eligieron Base y se salieron, al volver vuelve a Plus+ preseleccionado. Pedro 2026-06-27 */
      window.__agcPlan = 'plus';
      var _pw = document.getElementById('agcPlan');
      if (_pw) { _pw.setAttribute('data-plan', 'plus'); _pw.querySelectorAll('.agc-plan-row').forEach(function (r) { r.classList.toggle('is-sel', r.getAttribute('data-plan') === 'plus'); }); }
    }
    updateCta();
    requestAnimationFrame(placeAnnBar);   /* el card cambia de altura al entrar/salir del paso color → reanclar el annbar 12px arriba (Pedro 2026-06-21) */
  }
  (function () {
    var host = $('#agcColorStepRows');
    if (host) host.addEventListener('click', function (e) {
      var tg = e.target.closest('.agc-csperducha');
      if (tg) {   /* toggle entre color único (global) y distinto por ducha */
        state.colorPerDucha = tg.getAttribute('data-perducha') === 'on';
        if (!state.colorPerDucha) setGlobalColor(state.colors[0]);   /* al volver a "mismo", unifica al 1ro */
        buildColorStepRows();
        selectColor(state.colors[0]);
        return;
      }
      var sw = e.target.closest('.agc-cssw'); if (!sw) return;
      var key = sw.getAttribute('data-c');
      if (sw.getAttribute('data-row') === 'all') {   /* fila global → aplica a TODAS las duchas */
        setGlobalColor(key);
        sw.closest('.agc-csrow-sw').querySelectorAll('.agc-cssw').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-c') === key); });
        var lblA = sw.closest('.agc-csrow').querySelector('.agc-csrow-c'); if (lblA) lblA.textContent = _csColorName(key);
        return;
      }
      var n = +sw.getAttribute('data-row');
      state.colors[n] = key;
      host.querySelectorAll('.agc-cssw[data-row="' + n + '"]').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-c') === key); });
      var lblC = sw.closest('.agc-csrow').querySelector('.agc-csrow-c');   /* actualiza "Ducha N: {color}" (Pedro 2026-06-22) */
      if (lblC) lblC.textContent = _csColorName(key);
      selectColor(key); /* el hero refleja el último color tocado */
    });
    var back = $('#agcColorStepBack');
    if (back) back.addEventListener('click', function () { setStep('config'); });
  })();

  function syncSoldPill() {
    var sold = colorSoldOut();
    root.classList.toggle("is-soldout", sold);
    if (sold) {
      var c = colorByKey(state.colorKey);
      var span = document.querySelector('#agcSoldPill span');
      if (span && c) span.textContent = c.name + ' sold out';   /* nombre real completo (Pedro 2026-07-23) */
    }
  }

  /* ═══════════════ CART ENGINE (cart-morph) ═══════════════ */
  var CC = CFG.cart || {};
  var LASTCART = null;
  function jpost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function refreshCount() {
    getCart().then(function (c) { var el = $('#agcCartCount'); if (el) el.textContent = c.item_count; }).catch(function () {});
  }

  /* compare-at por item (hardcodes verificados del live) */
  function itemCompare(it) {
    if (it.product_id === CFG.duchaProductId) return CC.duchaCompareUnit * it.quantity;
    if (it.variant_id === CC.annualVariant) return CC.annualCompare * it.quantity;
    if (it.variant_id === CC.careVariant) return CC.careCompare * it.quantity;
    if (it.product_id === CC.tapeteProductId) return CC.tapeteCompare * it.quantity;
    return it.original_line_price;
  }
  function findItem(cart, pred) {
    for (var i = 0; i < cart.items.length; i++) if (pred(cart.items[i])) return cart.items[i];
    return null;
  }
  function duchaQty(cart) {
    var q = 0;
    cart.items.forEach(function (it) { if (it.product_id === CFG.duchaProductId && it.original_price !== 0) q += it.quantity; });
    return q;
  }

  /* render de una línea de carrito (glass) */
  function cartItemRow(it) {
    var el = document.createElement('div');
    el.className = 'agc-citem';
    el.setAttribute('data-key', it.key);
    var compare = itemCompare(it);
    /* FIX (Pedro 2026-06-21): el sufijo de resize va ANTES de la extensión (_120x$1$2), no reemplazándola — antes generaba "...png?"→"..._120x?" (sin .png) = imagen rota (Set Anual y cualquier item con it.image) */
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : (it.featured_image && it.featured_image.url) || '';
    /* ducha usa el render limpio del color elegido */
    var isDucha = it.product_id === CFG.duchaProductId;
    /* en el carrito la ducha conserva la foto con fondo cream (cartImg), no el render transparente */
    if (isDucha) { var cc = colorByVariant(it.variant_id) || colorByKey(state.colorKey); if (cc && (cc.cartImg || cc.img)) img = cc.cartImg || cc.img; }
    var sub = '';
    if (isDucha) {
      var cname = (it.options_with_values && it.options_with_values[0] && it.options_with_values[0].value) || (colorByVariant(it.variant_id) || colorByKey(state.colorKey)).name;
      sub = cname + (it.selling_plan_allocation ? ' · ' + it.selling_plan_allocation.selling_plan.name : '');
    } else if (it.selling_plan_allocation) {
      sub = it.selling_plan_allocation.selling_plan.name;
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      sub = it.variant_title;
    }
    var priceHtml = '<b>' + fmt(it.final_line_price) + '</b>' + (compare > it.final_line_price ? '<s>' + fmt(compare) + '</s>' : '');

    /* FILTRO INICIAL INCLUIDO (aguacero08): bundled/locked — sin qty, sin eliminar.
       1 por ducha, sincronizado por setDuchaQty. El cliente no lo edita directamente. */
    if (it.product_id === CFG.filtroProductId) {
      el.classList.add('agc-citem--locked');
      /* precio: $0 con el valor real del filtro ($590 c/u) tachado al lado (ancla de valor) */
      var fCompare = (CFG.filtroCompare || 59000) * it.quantity;
      var fPriceHtml = '<b>' + fmt(it.final_line_price) + '</b><s>' + fmt(fCompare) + '</s>';
      el.innerHTML =
        '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="agc-citinfo">' +
          '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
          '<div class="agc-citsub">' + it.quantity + '× Included with your shower</div>' +
        '</div>' +
        '<div class="agc-citright">' +
          '<div class="agc-citprice">' + fPriceHtml + '</div>' +
          '<div class="agc-citlocked" style="font-size:10.5px;opacity:.55;font-weight:600;letter-spacing:.03em;text-transform:uppercase;text-align:right;margin-top:2px">Included</div>' +
        '</div>';
      return el;
    }

    el.innerHTML =
      '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="agc-citinfo">' +
        '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
        (sub ? '<div class="agc-citsub">' + sub + '</div>' : '') +
      '</div>' +
      '<div class="agc-citright">' +
        '<div class="agc-citprice">' + priceHtml + '</div>' +
        '<div class="agc-citqtyrow">' +
          '<div class="agc-citqty"><button class="m" data-act="dec" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button class="p" data-act="inc" aria-label="Increase">+</button></div>' +
          '<button class="agc-citrm" data-act="rm" aria-label="Remove"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2m1 0-1 13H8L7 7"/></svg></button>' +
        '</div>' +
      '</div>';
    return el;
  }

  function renderCart(cart) {
    LASTCART = cart;
    /* estado VACÍO (espejo del cart live): oculta scroll+totales, muestra el empty con CTA "Seguir comprando" */
    var isEmpty = cart.item_count === 0;
    /* cart vacío → ocultar el "Finalizar pedido" + el ticker eta (no hay qué finalizar). Scopeado a cart-mode por CSS. */
    if (island) island.classList.toggle('cart-empty', isEmpty);
    var emptyEl = $('#agcCartEmpty');
    var scrollEl = root.querySelector('.agc-cartscroll');
    var totalsEl = root.querySelector('.agc-carttotals');
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (scrollEl) scrollEl.style.display = isEmpty ? 'none' : '';
    if (totalsEl) totalsEl.style.display = isEmpty ? 'none' : '';
    if (isEmpty) {
      var hn0 = $('#agcCartHeadN'); if (hn0) hn0.textContent = '';
      var cn0 = $('#agcCartCount'); if (cn0) cn0.textContent = '0';
      return;
    }
    var dq = duchaQty(cart);
    /* INVARIANTE (Pedro 2026-06-23): el Filtro Inicial Incluido = 1 por ducha, SIEMPRE.
       Red de seguridad self-healing: si quedó desincronizado por cualquier ruta (ej. quitar una
       ducha de un tier 2/3 sin que el sync corriera), reconciliar la qty del filtro AL # de duchas
       antes de pintar. Idempotente: el flag _filtroFixed en el cart evita re-entrar en loop si la
       corrección falla; tras un cambio exitoso getCart ya trae la qty correcta → no re-corre. */
    var fItem = findFiltro(cart);
    if (fItem && fItem.quantity !== dq && !cart._filtroFixed) {
      return jpost('/cart/change.js', { id: fItem.key, quantity: Math.max(0, dq) })
        .then(getCart)
        .then(function (c) { c._filtroFixed = true; return renderCart(c); })
        .catch(function () { cart._filtroFixed = true; return renderCart(cart); });
    }
    var hasAnnual = !!findItem(cart, function (i) { return i.variant_id === CC.annualVariant; });
    var hasCare = !!findItem(cart, function (i) { return i.variant_id === CC.careVariant || i.variant_id === CC.careGiftVariant; });
    var hasTapete = !!findItem(cart, function (i) { return i.product_id === CC.tapeteProductId; });

    /* líneas: ducha + annual + tapete (care y demás extras no se listan, viven en cross-sell) */
    var grid = $('#agcCartItems');
    grid.innerHTML = '';
    cart.items.forEach(function (it) {
      if (it.variant_id === CC.careVariant) return; /* care = toggle, no línea */
      grid.appendChild(cartItemRow(it));
    });

    /* cross-sell visibility */
    /* Set Anual de filtros: SOLO en tier 1 (qty ducha === 1). En tier 2+ no se ofrece. */
    var xAnnual = $('#agcXAnnual');
    if (xAnnual) xAnnual.hidden = !(dq === 1 && !hasAnnual);
    var xTapete = $('#agcXTapete');
    if (xTapete) xTapete.hidden = hasTapete;
    /* Care: al agregarlo la card DESAPARECE y aparecen las líneas de garantía */
    var xCare = $('#agcXCare');
    if (xCare) xCare.hidden = hasCare;
    var careToggle = $('#agcXCareToggle');
    if (careToggle) { careToggle.classList.toggle('on', hasCare); careToggle.setAttribute('aria-checked', hasCare ? 'true' : 'false'); }
    $$('.agc-ct-care').forEach(function (r) { r.hidden = !hasCare; });
    var warr = $('#agcCtWarr'); if (warr) { warr.textContent = hasCare ? '100 days' : '60 days'; warr.classList.toggle('agc-ct-on', hasCare); }

    /* totales */
    var compareTotal = 0;
    cart.items.forEach(function (it) { compareTotal += itemCompare(it); });
    $('#agcCtCount').textContent = cart.item_count;

    /* MODELO NUEVO: el descuento de tier vive en el precio del selling plan →
       cart.total_price YA es el precio correcto (no se computa nada, no hay RITUAL-A0).
       Subtotal real = cart.total_price. Tachado = compareTotal (precio lista). */
    var finalSub = cart.total_price;
    $('#agcCtSubFinal').textContent = fmt(finalSub);
    var sc = $('#agcCtSubCompare');
    if (compareTotal > finalSub) { sc.textContent = fmt(compareTotal); sc.style.display = ''; }
    else { sc.style.display = 'none'; }

    /* Línea de descuento: LEE el cart real (cart_level_discount_applications), igual que
       cart-drawer.liquid. Con selling plans no hay cart-level discount → queda oculta (correcto).
       Si en el futuro hay un código de cupón, lo muestra automáticamente. */
    var disc = $('#agcCtDiscount');
    if (disc) {
      var cdis = (cart.cart_level_discount_applications || []).filter(function (d) { return (d.total_allocated_amount || 0) > 0; });
      if (cdis.length) {
        var dTotal = 0;
        cdis.forEach(function (d) { dTotal += (d.total_allocated_amount || 0); });
        $('#agcCtDiscountLabel').textContent = 'Code applied · ' + (cdis[0].title || cdis[0].code || '');
        $('#agcCtDiscountAmt').textContent = '−' + fmt(dTotal);
        disc.hidden = false;
      } else { disc.hidden = true; }
    }

    var headN = $('#agcCartHeadN'); if (headN) headN.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    var cnt = $('#agcCartCount'); if (cnt) cnt.textContent = cart.item_count;
  }

  function reloadCart() { return getCart().then(renderCart); }

  /* mutaciones */
  function cartChange(key, qty) {
    return jpost('/cart/change.js', { id: key, quantity: qty }).then(renderCart);
  }
  /* tier↔plan sync DENTRO del cart: el tier = qty de la ducha, y CADA tier tiene su PROPIO
     selling plan (descuento creciente vía Kaching). /cart/change.js NO cambia selling_plan →
     al subir O bajar qty hay que remover la línea ducha y re-agregarla con el plan correcto,
     o el cliente baja a tier 1 conservando el descuento de tier 2/3 (bug). tier 3 y arriba =
     mismo plan (índice 2). qty 0 = quitar la línea. Preserva el color actual. */
  /* Filtro Inicial Incluido: 1 por ducha, bundled. Se sincroniza a la qty de la ducha
     y se elimina con ella. NUNCA editable por el cliente directamente. */
  function findFiltro(cart) {
    return findItem(cart, function (i) { return i.product_id === CFG.filtroProductId; });
  }
  function setDuchaQty(n) {
    if (!LASTCART) return Promise.resolve();
    var d = findItem(LASTCART, function (i) { return i.product_id === CFG.duchaProductId && i.original_price !== 0; });
    if (!d) return Promise.resolve();
    var f = findFiltro(LASTCART);
    if (n <= 0) {
      /* quitar ducha = quitar también su filtro inicial (bundled) */
      return jpost('/cart/change.js', { id: d.key, quantity: 0 })
        .then(function () { return f ? jpost('/cart/change.js', { id: f.key, quantity: 0 }) : null; })
        .then(reloadCart)
        .then(function () { startCartBar(); loadTapeteSheet(); });
    }
    /* MODELO NUEVO (2026-06-21): ducha one-time → cambiar qty directo. El Filtro Inicial
       (1 por ducha) se sincroniza a la misma qty. El descuento de tier (30/33/40%) lo
       re-evalúa el descuento automático de Kaching según la qty de duchas. /cart/change.js
       por key preserva el selling_plan del filtro. */
    state.tier = Math.min(n, 3);
    return jpost('/cart/change.js', { id: d.key, quantity: n })
      .then(function () { return f ? jpost('/cart/change.js', { id: f.key, quantity: n }) : null; })
      .then(function () { return reloadCart(); })
      .then(function () { startCartBar(); loadTapeteSheet(); })
      .catch(function () { reloadCart(); });
  }
  /* MULTI-COLOR (Pedro 2026-06-21): cambia una línea de ducha ESPECÍFICA (por key) y
     re-sincroniza el filtro al TOTAL de duchas (1 filtro por ducha). Correcto para 1 línea
     (single color) o varias (colores mixtos). El descuento de tier lo re-evalúa Kaching. */
  function setDuchaLineQty(key, n) {
    return jpost('/cart/change.js', { id: key, quantity: Math.max(0, n) })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var total = duchaQty(cart);
        state.tier = Math.min(Math.max(total, 1), 3);
        var f = findFiltro(cart);
        if (f && f.quantity !== total) return jpost('/cart/change.js', { id: f.key, quantity: Math.max(0, total) }).then(getCart);
        return cart;
      })
      .then(renderCart)
      .then(function () { startCartBar(); loadTapeteSheet(); })
      .catch(function () { reloadCart(); });
  }

  /* eventos del carrito (delegación) */
  $('#agcCartItems').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]'); if (!btn) return;
    var row = btn.closest('.agc-citem'); if (!row) return;
    var key = row.getAttribute('data-key');
    var item = findItem(LASTCART, function (i) { return i.key === key; });
    if (!item) return;
    var act = btn.dataset.act;
    /* #2 feedback: press táctil + loading durante el cambio async (patrón cart LIVE) */
    btn.classList.add('is-pressed'); setTimeout(function () { btn.classList.remove('is-pressed'); }, 130);
    var qtyCtl = btn.closest('.agc-citqty'); if (qtyCtl) qtyCtl.classList.add('is-loading');
    /* la basurita vive FUERA de .agc-citqty → su propio spinner (Pedro 2026-06-21: el delete tarda ~2s sin feedback) */
    if (btn.dataset.act === 'rm') btn.classList.add('is-removing');
    /* la DUCHA enruta su qty por setDuchaQty → re-mapea el selling plan al tier nuevo (subir Y bajar).
       Los demás ítems cambian qty normal. */
    var isDuchaItem = item.product_id === CFG.duchaProductId && item.original_price !== 0;
    var p;
    if (act === 'rm') p = isDuchaItem ? setDuchaLineQty(key, 0) : cartChange(key, 0);
    else if (act === 'dec') { var dq = Math.max(0, item.quantity - 1); p = isDuchaItem ? setDuchaLineQty(key, dq) : cartChange(key, dq); }
    else if (act === 'inc') { var iq = item.quantity + 1; p = isDuchaItem ? setDuchaLineQty(key, iq) : cartChange(key, iq); }
    if (p && p.catch) p.catch(function () { if (qtyCtl) qtyCtl.classList.remove('is-loading'); btn.classList.remove('is-removing'); });
  });

  /* cross-sell: Set Anual */
  var xAnnualBtn = $('#agcXAnnualBtn');
  if (xAnnualBtn) xAnnualBtn.addEventListener('click', function () {
    if (xAnnualBtn.hasAttribute('disabled')) return;
    xAnnualBtn.setAttribute('disabled', ''); xAnnualBtn.classList.add('is-loading'); xAnnualBtn.textContent = 'Adding…';   /* feedback inmediato (Pedro 2026-06-21) */
    jpost('/cart/add.js', { items: [{ id: CC.annualVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { xAnnualBtn.removeAttribute('disabled'); xAnnualBtn.classList.remove('is-loading'); xAnnualBtn.textContent = 'Add'; })
      .catch(function () { xAnnualBtn.removeAttribute('disabled'); xAnnualBtn.classList.remove('is-loading'); xAnnualBtn.textContent = 'Add'; });
  });

  /* cross-sell: Aguacero Care (opt-in toggle, sin auto-add) */
  var careToggle = $('#agcXCareToggle');
  if (careToggle) careToggle.addEventListener('click', function () {
    if (careToggle.classList.contains('is-loading')) return;
    var on = careToggle.classList.contains('on');
    careToggle.classList.add('is-loading');   /* feedback inmediato (Pedro 2026-06-21) */
    if (on) {
      var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
      var p = c ? cartChange(c.key, 0) : Promise.resolve();
      p.then(function () { careToggle.classList.remove('is-loading'); });
    } else {
      careToggle.classList.add('on');   /* optimista: el check aparece al instante */
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] }).then(reloadCart)
        .then(function () { careToggle.classList.remove('is-loading'); })
        .catch(function () { careToggle.classList.remove('on'); careToggle.classList.remove('is-loading'); });
    }
  });
  var careRemove = $('#agcCtCareRemove');
  if (careRemove) careRemove.addEventListener('click', function () {
    var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
    if (c) cartChange(c.key, 0);
  });

  /* cross-sell: Tapete (sheet de detalles) */
  var TAP_IMGS = null;
  function loadTapeteSheet() {
    var box = $('#agcTapImgs');
    if (TAP_IMGS) return;
    fetch('/products/' + CC.tapeteHandle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      TAP_IMGS = (p.images || []).slice(0, 5).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
      box.innerHTML = TAP_IMGS.map(function (u) { return '<img src="' + u + '&width=560" alt="" loading="lazy">'; }).join('');
      var th = $('#agcXTapeteThumb');
      if (th && TAP_IMGS[0]) th.innerHTML = '<img src="' + TAP_IMGS[0] + '&width=120" alt="" loading="lazy">';
      var pr = $('#agcTapPrice'); if (pr && p.price) pr.textContent = fmt(p.price);
    }).catch(function () {});
  }
  function openTapeteOrCare(which) {
    var ov = $('#agcTapSheet');
    if (ov) { ov.classList.remove('closing'); ov.classList.add('show'); }
  }
  var xTapBtn = $('#agcXTapeteBtn');
  if (xTapBtn) xTapBtn.addEventListener('click', function () { openTapeteOrCare('tapete'); });
  var tapClose = $('#agcTapClose');
  if (tapClose) tapClose.addEventListener('click', function () { animClose($('#agcTapSheet')); });
  var tapOv = $('#agcTapSheet');
  if (tapOv) tapOv.addEventListener('click', function (e) { if (e.target === tapOv) animClose(tapOv); });
  var tapAdd = $('#agcTapAdd');
  if (tapAdd) tapAdd.addEventListener('click', function () {
    tapAdd.setAttribute('disabled', '');
    jpost('/cart/add.js', { items: [{ id: CC.tapeteVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { animClose($('#agcTapSheet')); tapAdd.removeAttribute('disabled'); })
      .catch(function () { tapAdd.removeAttribute('disabled'); });
  });

  /* barra social rotativa del carrito */
  var cbIdx = 0, cbTimer = null;
  function startCartBar() {
    var items = $$('#agcCartBar span');
    if (!items.length || cbTimer) return;
    cbTimer = setInterval(function () {
      items[cbIdx].classList.remove('on');
      cbIdx = (cbIdx + 1) % items.length;
      items[cbIdx].classList.add('on');
    }, 5000);
  }
  function stopCartBar() { if (cbTimer) { clearInterval(cbTimer); cbTimer = null; } }

  /* ── CTA principal: collapsed→config, config→ATC+morph, cart→checkout ── */
  $('#agcAddBtn').addEventListener('click', function () {
    if (state.busy) return;
    if (inCart()) { checkoutOrCare(); return; }
    /* fuera de la primera pantalla: "Comprar Aguacero" desliza al usuario de regreso al above-the-fold Y abre la card (1 click). slideUpToCard detecta scroll de ventana O scroller (en embed scrollea la ventana, no el scroller — por eso el viejo check de .scrolled no disparaba). Pedro 2026-06-22 */
    if (!islandOpen() && slideUpToCard()) { closeMenu(); setMode('config'); return; }
    /* "Comprar ahora" SIEMPRE expande la card (nunca se bloquea) */
    if (!islandOpen()) { closeMenu(); setMode('config'); return; }
    /* paso de color (Pedro 2026-06-21): card abierta en step 'config' → 1er click abre el
       paso de elegir color(es). En step 'color' → procede al ATC. */
    if (state.step === 'config') { setStep('color'); return; }
    /* card abierta + color agotado → guía a elegir un color disponible */
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (availC) selectColor(availC.key);
      return;
    }
    /* ATC explícito en GET ZERO (Pedro 2026-07-22): el nativo solo dispara en cart/add (tarde en T1,
       y corre carrera contra el redirect). Este captura la INTENCIÓN al elegir acabado, en todos los tiers. */
    if (state.step === 'color' && typeof fbq === 'function') {
      try {
        var _atcT = totals();
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: state.colors.map(function (k) { return String(colorByKey(k).variantId); }),
          value: _atcT.today / 100, currency: 'USD', num_items: state.tier
        });
      } catch (e) {}
    }
    /* color step (Pedro 2026-07-21): solo T1 → step Care (upsell $19); T2/T3 → checkout directo (Care va GRATIS de regalo). */
    if (state.step === 'color' && state.tier < 2) { setStep('care'); return; }
    proceedCheckout(false);
  });

  /* ATC + checkout factorizado (Pedro 2026-06-29). addCare = agregar Aguacero Care PAGADO (solo T1/T2 desde el step). */
  function proceedCheckout(addCare) {
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (availC) selectColor(availC.key);
      return;
    }
    state.busy = true;
    var btn = $('#agcAddBtn');
    if (btn) btn.setAttribute('disabled', '');
    var label = $('#agcCtaLabel');
    if (label) label.textContent = CTA_DIRECT_CHECKOUT ? 'Changing your water…' : 'Adding…';
    /* agrupa los colores elegidos por ducha → 1 línea por variant (mismo color suma qty) */
    ensureColorsLen();
    var counts = {};
    state.colors.forEach(function (k) { var vid = colorByKey(k).variantId; counts[vid] = (counts[vid] || 0) + 1; });
    var atcItems = Object.keys(counts).map(function (vid) { return { id: Number(vid), quantity: counts[vid] }; });
    /* PLAN (Pedro 2026-06-27): Plus+ = filtro suscripción ($0 1ª vez → $590/90d); Única = filtro $290 SIN plan, 1 por ducha. Default 'plus'. */
    var _agcPlan = window.__agcPlan || 'plus';
    if (_agcPlan === 'once' && CFG.filtroOnceVariantId) {
      atcItems.push({ id: Number(CFG.filtroOnceVariantId), quantity: state.tier });
    } else if (CFG.filtroVariantId) {
      var fItem = { id: CFG.filtroVariantId, quantity: state.tier };
      if (CFG.filtroPlanId) fItem.selling_plan = CFG.filtroPlanId;
      atcItems.push(fItem);
    }
    /* Regalos (Pedro 2026-07-21): Care GRATIS en T2 y T3 (variante Gift $0). Tapete FUERA — DiatoMAT US en draft. */
    var _careGiftV = CC.careGiftVariant || CC.careVariant;
    if (_careGiftV && state.tier >= 2) atcItems.push({ id: Number(_careGiftV), quantity: 1 });
    /* Care PAGADO ($19) solo T1 si lo eligió en el step. */
    if (addCare && state.tier < 2 && CC.careVariant) atcItems.push({ id: Number(CC.careVariant), quantity: 1 });
    /* El pedido se arma desde cero en cada intento de compra. Este clear vive aquí (y ya no en
       pageshow) para que el carrito sobreviva al "back" del checkout sin acumular duchas. Si el
       clear falla, la compra procede igual — nunca debe bloquear el add. */
    var freshAdd = jpost('/cart/clear.js', {})
      .catch(function () {})
      .then(function () { return jpost('/cart/add.js', { items: atcItems }); });
    /* DIRECTO A CHECKOUT (Pedro 2026-06-25): 1 sola AJAX + redirect. */
    if (CTA_DIRECT_CHECKOUT) {
      freshAdd
        .then(function () {
          /* EL BOLETO: re-adjuntar la predicción como cart attributes (el clear previo al add los borra) → viajan a note_attributes de la orden */
          var mp = null; try { mp = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
          /* INTEGRIDAD: solo antes del silbatazo — nadie "gana" comprando con el resultado ya puesto */
          if (mp && mp.pick && (!mp.kickoff || Date.now() < mp.kickoff)) return (window.__agcMunAttach ? window.__agcMunAttach({ 'Mundial partido': mp.partido, 'Mundial marcador': mp.pick, 'Mundial WhatsApp aviso': mp.phone }) : jpost('/cart/update.js', { attributes: { 'Mundial partido': mp.partido, 'Mundial marcador': mp.pick, 'Mundial WhatsApp aviso': mp.phone } })).catch(function () {});
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { console.error('[AGC-CFG] add error', err); if (label) label.textContent = 'Something went wrong — try again'; setTimeout(updateCta, 2200); state.busy = false; if (btn) btn.removeAttribute('disabled'); });
      return;
    }
    freshAdd
      .then(function () {
        return reloadCart().then(function () { loadTapeteSheet(); setMode('cart'); startCartBar(); });
      })
      .catch(function (err) {
        console.error('[AGC-CFG] add error', err);
        if (label) label.textContent = 'Something went wrong — try again';
        setTimeout(updateCta, 2200);
      })
      .then(function () { state.busy = false; if (btn) btn.removeAttribute('disabled'); });
  }

  /* Step Care: sus propios botones (Pedro 2026-06-29) */
  (function () {
    var yes = $('#agcCareStepYes'), no = $('#agcCareStepNo'), back = $('#agcCareStepBack');
    if (yes) yes.addEventListener('click', function () { if (state.busy) return; yes.classList.add('is-busy'); proceedCheckout(true); });
    if (no) no.addEventListener('click', function () { if (state.busy) return; no.classList.add('is-busy'); proceedCheckout(false); });
    if (back) back.addEventListener('click', function () { setStep('color'); });
  })();

  /* DIRECT-CHECKOUT (Pedro 2026-06-25): el cart es EFÍMERO (solo vehículo a checkout). Se vacía cada vez que se MUESTRA la landing (carga inicial + "back" del checkout — pageshow cubre ambos, incl. bfcache de webviews in-app Meta/IG) y se ponen en 0 AMBOS badges: el del configurador (#agcCartCount) y el del menú de arriba ([data-agcn-count] de agc-nav). Así el form POST nunca acumula y el badge no queda "lleno". */
  window.addEventListener('pageshow', function () {
    if (!CTA_DIRECT_CHECKOUT) return;
    /* RESET DEL CTA (Pedro 2026-06-26): al volver del checkout con "back", el bfcache restaura el DOM tal cual → el botón queda disabled + opaco con label "Cambiando tu agua…" y state.busy=true. Hay que destrabarlo. Como el click setea label.textContent directo (sin setCtaLabel), el cache dataset.cur NO se actualizó → invalidarlo para forzar el re-render del label correcto vía updateCta(). */
    state.busy = false;
    var _b = $('#agcAddBtn'); if (_b) _b.removeAttribute('disabled');
    var _l = $('#agcCtaLabel'); if (_l) { _l.style.opacity = '1'; _l.dataset.cur = ''; }
    try { updateCta(); } catch (x) {}
    var _cy = $('#agcCareStepYes'); if (_cy) _cy.classList.remove('is-busy');   /* back desde checkout en step Care → destraba el loading; el cart se limpia abajo → Care se quita (Pedro 2026-06-29) */
    var _cn = $('#agcCareStepNo'); if (_cn) _cn.classList.remove('is-busy');
    /* CARRITO PRESERVADO (2026-08-06): aquí se vaciaba el carrito, así que volver del checkout
       con "back" borraba el pedido ya armado (medido en US: 6 de 7 checkouts abandonados tenían
       dirección capturada). La acumulación que ese clear evitaba ahora se previene en
       proceedCheckout(), que limpia justo antes de armar el pedido. */
    getCart().then(function (c) {
      document.querySelectorAll('#agcCartCount, [data-agcn-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
    try { reloadCart(); } catch (x) {}
  });

  /* ══ EL BOLETO — STEP NATIVO dentro del configurador (Pedro 2026-07-03).
     Gemelo del step Care: root.agc-step-mun muestra #agcMunStepSect y oculta el resto.
     Data pipeline INTACTO: localStorage + cart attributes con retry + Klaviyo + kickoff guard. ══ */
  (function () {
    var mun = document.getElementById('agcMunStepSect'); if (!mun) return;
    window.__agcMunAttach = function (attrs) {
      return jpost('/cart/update.js', { attributes: attrs }).catch(function () {
        return new Promise(function (res) { setTimeout(res, 900); }).then(function () {
          return jpost('/cart/update.js', { attributes: attrs });
        });
      });
    };
    var kickoff = Date.parse(mun.getAttribute('data-kickoff') || '') || 0;
    var partido = mun.getAttribute('data-partido') || 'MEX-ENG';
    var flapM = document.getElementById('agcFlapMex'), flapE = document.getElementById('agcFlapEng');
    var phone = document.getElementById('agcMunPhone'), listo = document.getElementById('agcMunListo');
    if (phone) phone.addEventListener('input', function () { phone.value = phone.value.replace(/\D/g, '').slice(0, 10); });
    var countEl = document.getElementById('agcMunCount');
    var vals = { mex: null, eng: null }, cIv = null;

    function pickToAnnbar(pick) {
      var bar = document.getElementById('agcAnnBar'); if (!bar) return;
      var sp = bar.querySelector('.agc-annbar-mun');
      if (!sp) { sp = document.createElement('span'); sp.className = 'agc-annbar-msg agc-annbar-mun'; bar.appendChild(sp); }
      sp.textContent = '\ud83c\udf9f\ufe0f Your ticket ' + String(pick).replace('-', '\u2013') + ' is locked in with this order';
    }
    var inline = document.getElementById('agcMunInline'), inlineScore = document.getElementById('agcMunInlineScore');
    function syncInline(pick) {
      if (!inline) return;
      if (inlineScore) inlineScore.textContent = 'MEX ' + String(pick).replace('-', '\u2013') + ' ENG';
      inline.hidden = false;
    }
    function syncListo() { if (listo) listo.disabled = (vals.mex === null || vals.eng === null); }
    function applyPick(pick) {
      var m = String(pick).split('-');
      vals.mex = +m[0]; vals.eng = +m[1];
      if (flapM) { flapM.querySelector('.fv').textContent = vals.mex; flapM.classList.remove('is-empty'); }
      if (flapE) { flapE.querySelector('.fv').textContent = vals.eng; flapE.classList.remove('is-empty'); }
      syncListo();
    }
    var saved = null; try { saved = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
    if (saved && saved.partido === partido) { pickToAnnbar(saved.pick); syncInline(saved.pick); applyPick(saved.pick); if (phone && saved.phone) phone.value = saved.phone; }

    function stepOpen(force) {
      if (kickoff && Date.now() >= kickoff) return false;
      if (!force) {
        try { if (sessionStorage.getItem('agcMunSeen')) return false; } catch (e) {}
        /* ya selló un boleto → no re-mostrar el step (su pick vive en el mini-boleto de tiers; "Cambiar" lo reabre) */
        try { var sp = JSON.parse(localStorage.getItem('agcMunPick') || 'null'); if (sp && sp.pick && sp.partido === partido) return false; } catch (e) {}
      }
      root.classList.add('agc-step-mun'); tickCount();
      return true;
    }
    function stepClose() {
      root.classList.remove('agc-step-mun');
      try { sessionStorage.setItem('agcMunSeen', '1'); } catch (e) {}
      requestAnimationFrame(placeAnnBar);
    }
    window.__agcMunMaybeOpen = function () { return stepOpen(false); };
    var skip = document.getElementById('agcMunSkip2'); if (skip) skip.addEventListener('click', stepClose);
    var inlineEdit = document.getElementById('agcMunInlineEdit');
    if (inlineEdit) inlineEdit.addEventListener('click', function () {
      var sv = null; try { sv = JSON.parse(localStorage.getItem('agcMunPick') || sessionStorage.getItem('agcMunPick') || 'null'); } catch (e) {}
      if (sv && sv.pick) { applyPick(sv.pick); if (phone && sv.phone) phone.value = sv.phone; }
      stepOpen(true);   /* reabrir ignora el seen: es acción explícita */
    });
    var terms = document.getElementById('agcMunTerms'), legal = document.getElementById('agcMunLegal');
    if (terms && legal) terms.addEventListener('click', function () {
      legal.hidden = !legal.hidden;
      terms.textContent = legal.hidden ? 'Terms' : 'Close terms ↑';
      if (!legal.hidden) legal.scrollTop = 0;
    });

    function setFlap(el, side, d) {
      var v = vals[side] === null ? (d > 0 ? 1 : 0) : Math.max(0, Math.min(7, vals[side] + d));
      if (vals[side] !== null && v === vals[side]) return;
      vals[side] = v;
      el.classList.remove('flip'); void el.offsetWidth; el.classList.add('flip'); el.classList.remove('is-empty');
      setTimeout(function () { el.querySelector('.fv').textContent = v; }, 95);
      syncListo();
    }
    mun.addEventListener('click', function (e) {
      var b = e.target.closest('.agc-mun-step'); if (!b) return;
      setFlap(b.getAttribute('data-side') === 'mex' ? flapM : flapE, b.getAttribute('data-side'), +b.getAttribute('data-d'));
    });

    function tickCount() {
      if (!countEl || cIv) return;
      function t() {
        var diff = kickoff - Date.now();
        if (diff <= 0) { countEl.textContent = 'kickoff!'; stepClose(); clearInterval(cIv); cIv = null; return; }
        var sec = Math.floor(diff / 1000), dd = Math.floor(sec / 86400); sec -= dd * 86400;
        var h = Math.floor(sec / 3600); sec -= h * 3600; var m = Math.floor(sec / 60); sec -= m * 60;
        countEl.textContent = (dd > 0 ? dd + 'D ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
      }
      t(); cIv = setInterval(t, 1000);
    }
    /* Contador de boletos: determinista (mismo valor para todos según la hora). VOLUMEN, nunca distribución. */
    function boletosNow() {
      var t0 = Date.UTC(2026, 6, 3, 2, 0, 0);
      var now = Date.now(), n = 340, t = t0;
      if (now <= t0) return n;
      var hrs = (now - t0) / 3600000;
      for (var h = 0; h < Math.floor(hrs); h++) {
        var cdmxH = (20 + h) % 24;
        n += (cdmxH >= 8 && cdmxH < 24) ? 55 : 14;
      }
      var frac = hrs - Math.floor(hrs), curH = (20 + Math.floor(hrs)) % 24;
      n += Math.floor(frac * ((curH >= 8 && curH < 24) ? 55 : 14));
      return n;
    }
    var volEl = document.getElementById('agcMunVol');
    function syncVol() { if (volEl) volEl.textContent = boletosNow().toLocaleString('en-US'); }
    syncVol(); setInterval(syncVol, 45000);

    if (listo) listo.addEventListener('click', function () {
      if (vals.mex === null || vals.eng === null) return;
      /* captura de WhatsApp (Pedro 2026-07-05: más confianza que correo): aviso al ganador + alta Klaviyo por teléfono. 10 dígitos requeridos para sellar. */
      var ph = (phone && phone.value || '').replace(/\D/g, '');
      if (ph.length !== 10) { if (phone) { phone.classList.remove('err'); void phone.offsetWidth; phone.classList.add('err'); phone.focus(); } return; }
      listo.classList.add('is-busy');
      var pick = vals.mex + '-' + vals.eng;
      try { localStorage.setItem('agcMunPick', JSON.stringify({ pick: pick, partido: partido, phone: ph, kickoff: kickoff })); } catch (e) {}
      window.__agcMunAttach({ 'Mundial partido': partido, 'Mundial marcador': pick, 'Mundial WhatsApp aviso': ph }).catch(function () {});
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + ((CFG && CFG.klaviyoCompany) || 'SFNwUe'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { phone_number: '+52' + ph, properties: { mundial_partido: partido, mundial_marcador: pick, mundial_whatsapp: ph } } } } }, relationships: { list: { data: { type: 'list', id: (CFG && CFG.klaviyoList) || 'TmrPHJ' } } } } })
        }).catch(function () {});
      } catch (e) {}
      setTimeout(function () {
        listo.classList.remove('is-busy');
        listo.querySelector('span').textContent = 'Ticket locked in \u2713';
        setTimeout(function () {
          pickToAnnbar(pick); syncInline(pick); stepClose();
          listo.querySelector('span').textContent = 'Lock in my ticket';
        }, 850);
      }, 650);
    });
  })();

/* ── NUDGE del CTA (Pedro 2026-08-01) ──────────────────────────────────────
     5s sin interacción → .agc-idle en el root y el borde de luz se enciende
     (todo el efecto vive en agc-cfg.css). Cualquier señal de avance lo apaga.
     A propósito NO escucha pointermove: quien mueve el mouse leyendo el precio
     es justo a quien hay que empujar. Sin rAF — un timer y ya. */
  (function () {
    var IDLE_MS = 5000, timer = null;

    function wake() {
      root.classList.remove('agc-idle');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        if (!state.busy) root.classList.add('agc-idle');
      }, IDLE_MS);
    }

    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, wake, { passive: true });
    });
    window.addEventListener('scroll', wake, { passive: true });

    /* pestaña en segundo plano: nada que empujar, y no gastamos frames */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        root.classList.remove('agc-idle');
        if (timer) { clearTimeout(timer); timer = null; }
      } else { wake(); }
    });

    wake();
  })();

  buildStrip(state.colorKey);
  setHeroColor(state.colorKey);
  syncThumb();
  syncSoldPill();
  render();
  refreshCount();
})();
